// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mClubSendInvitationsFormWidth {
  max-width: 700px;
}

.eClubStudentsTitle,
.eClubMessagesTitle {
  display: inline-block;
  vertical-align: middle;
}

.bMessages,
.bParticipants {
  margin-top: 10px;
}

.bReportFormTitle {
  font-size: 18px;
  font-weight: bold;
}

/* Activate modal polish */
.cActivateModal {
  padding-top: 6px;
}

.cActivateModal__summary {
  display: grid;
  gap: 12px;
  margin-bottom: 10px;
}

.cActivateModal__summaryCard {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 12px 14px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.04);
}

.cActivateModal__clubName {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 8px;
}

.cActivateModal__grid {
  display: grid;
  grid-template-columns: 1fr auto;
  row-gap: 6px;
  column-gap: 10px;
  font-size: 13px;
}

.cActivateModal__label {
  color: rgba(0, 0, 0, 0.55);
}
.cActivateModal__value {
  font-weight: 600;
}

.cActivateModal__note {
  border-radius: 10px;
  padding: 10px 12px;
  background: rgba(0, 0, 0, 0.04);
  color: rgba(0, 0, 0, 0.75);
  font-size: 13px;
  margin: 8px 0 12px;
}

.cActivateModal__note.isError {
  background: rgba(220, 53, 69, 0.08);
  color: rgba(220, 53, 69, 0.95);
  font-weight: 600;
}

/* Occurrences block */
.cActivateModal__occ {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 12px 14px;
  background: #fff;
}

.cActivateModal__occHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.cActivateModal__occTitle {
  font-weight: 800;
  font-size: 14px;
}
.cActivateModal__occHint {
  color: rgba(0, 0, 0, 0.55);
  font-size: 12.5px;
  margin-top: 2px;
}

.cActivateModal__occSearch {
  width: 240px;
}

.cActivateModal__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 10px 0 10px;
  padding: 10px 10px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.03);
}

.cActivateModal__count {
  color: rgba(0, 0, 0, 0.6);
  font-size: 13px;
}

.cActivateModal__list {
  max-height: 260px;
  overflow: auto;
  padding-right: 6px;
}

.cActivateModal__row {
  display: grid;
  grid-template-columns: 18px 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 10px;
  border: 1px solid transparent;
  cursor: pointer;
  user-select: none;
}

.cActivateModal__row:hover {
  background: rgba(0, 0, 0, 0.03);
}

.cActivateModal__row.isChecked {
  border-color: rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.02);
}

.cActivateModal__date {
  font-weight: 650;
  font-size: 13px;
}
.cActivateModal__time {
  color: rgba(0, 0, 0, 0.55);
  font-size: 13px;
}

.cActivateModal__muted {
  color: rgba(0, 0, 0, 0.55);
  font-size: 13px;
  padding: 8px 2px;
}

.cActivateModal__empty {
  padding: 10px 2px;
}

.cActivateModal__emptyTitle {
  font-weight: 750;
  margin-bottom: 2px;
}

.cActivateModal__list {
  min-height: 140px;
}

.mActivateStats {
  display: grid;
  row-gap: 6px;
}

.mActivateStatsRow {
  display: grid;
  grid-template-columns: 170px max-content;
  column-gap: 12px;
  align-items: center;
}

.mActivateStatsLabel {
  color: #6c757d;
  font-size: 13px;
}

.mActivateStatsValue {
  text-align: left;
  font-weight: 600;
  color: #343a40;
}

.mActivateOccurrences input[type='checkbox'] {
  accent-color: #adb5bd;
}

/* New design: club activation */
.clubsActivateModal .modal-body {
  padding: 20px 24px !important;
}

.clubsActivateModal .modal-footer .btn-secondary {
  border-color: #cfd8e3 !important;
  background: #fff !important;
  background-image: none !important;
  color: #142033 !important;
}

.clubsActivateModal .modal-footer .btn-primary {
  border-color: #227ebd !important;
  background: #227ebd !important;
  background-image: none !important;
  color: #fff !important;
  box-shadow: 0 8px 18px rgba(34, 126, 189, 0.22) !important;
}

.clubsActivateModal .modal-footer .btn-primary:hover:not(:disabled),
.clubsActivateModal .modal-footer .btn-primary:focus:not(:disabled) {
  border-color: #1a6da3 !important;
  background: #1a6da3 !important;
  background-image: none !important;
}

.clubsActivateModal .modal-footer .btn-secondary:hover:not(:disabled),
.clubsActivateModal .modal-footer .btn-secondary:focus:not(:disabled) {
  border-color: #9fb0c3 !important;
  background: #f7f9fc !important;
  background-image: none !important;
}

.cActivateModal {
  display: grid;
  gap: 16px;
  padding: 0;
}

.cActivateModal__intro {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cActivateModal__introIcon {
  display: grid;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  place-items: center;
  border-radius: 10px;
  background: var(--surface-subtle, #f1f5f9);
  color: var(--action-primary, #1674d1);
}

.cActivateModal__introIcon svg,
.cActivateModal__note svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.cActivateModal__intro > div,
.cActivateModal__sectionHead > div {
  display: grid;
  gap: 2px;
}

.cActivateModal__intro strong,
.cActivateModal__sectionHead strong,
.cActivateModal__occTitle {
  color: var(--text-strong, #142033);
  font-size: 14px;
  font-weight: 700;
}

.cActivateModal__intro span,
.cActivateModal__sectionHead span,
.cActivateModal__occHint {
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 400;
}

.cActivateModal__sectionHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 2px;
}

.cActivateModal__sectionCount {
  display: inline-grid;
  min-width: 24px;
  height: 24px;
  padding: 0 7px;
  place-items: center;
  border-radius: 999px;
  background: var(--surface-subtle, #eef2f7);
  color: var(--text-body, #334155) !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

.cActivateModal__summary {
  display: block;
  overflow: hidden;
  margin: 0;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: #fff;
}

.cActivateModal__summaryCard {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) minmax(310px, auto);
  align-items: center;
  gap: 18px;
  padding: 12px 14px;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.cActivateModal__summaryCard + .cActivateModal__summaryCard {
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.cActivateModal__clubName {
  overflow: hidden;
  margin: 0;
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mActivateStats {
  display: grid;
  grid-template-columns: repeat(3, minmax(92px, 1fr));
  gap: 14px;
}

.mActivateStatsRow {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.mActivateStatsLabel {
  color: var(--text-muted, #64748b);
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 0.035em;
  text-transform: uppercase;
}

.mActivateStatsValue {
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 650;
}

.cActivateModal__note {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin: 0;
  padding: 10px 12px;
  border: 1px solid var(--info-border, #bfdbfe);
  border-radius: 9px;
  background: var(--info-surface, #eff6ff);
  color: var(--info-text, #1e5f99);
  font-size: 13px;
  font-weight: 400;
}

.cActivateModal__note svg {
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  margin-top: 1px;
}

.cActivateModal__note.isError {
  border-color: var(--danger-border, #fecdd3);
  background: var(--danger-surface, #fff1f2);
  color: var(--danger-text, #be123c);
  font-weight: 400;
}

.cActivateModal__occ {
  margin-top: 20px;
  padding: 18px 0 0;
  border: 0;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 0;
}

.cActivateModal__occHeader {
  align-items: center;
  margin-bottom: 10px;
}

.cActivateModal__occSearch {
  display: grid;
  width: 82px;
  gap: 4px;
  color: var(--text-muted, #64748b);
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cActivateModal__occSearch input {
  width: 100%;
  height: 36px;
  padding: 0 10px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  outline: none;
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 400;
}

.cActivateModal__occSearch input:focus {
  border-color: var(--action-primary, #1674d1);
  box-shadow: 0 0 0 3px rgba(22, 116, 209, 0.12);
}

.cActivateModal__actions {
  margin: 10px 0 8px;
  padding: 0;
  background: transparent;
}

.cActivateModal__actionsLeft {
  display: flex;
  gap: 12px;
}

.cActivateModal__actionsLeft button {
  padding: 0;
  border: 0;
  background: none;
  color: var(--action-primary, #1674d1);
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.cActivateModal__count {
  color: var(--text-muted, #64748b);
  font-size: 12px;
}

.cActivateModal__list {
  min-height: 120px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 9px;
}

.cActivateModal__row {
  min-height: 40px;
  padding: 8px 10px;
  border: 0;
  border-bottom: 1px solid var(--border-subtle, #edf1f5);
  border-radius: 0;
}

.cActivateModal__row:hover {
  background: var(--surface-hover, #f8fafc);
}

.cActivateModal__row.isChecked {
  border-color: var(--border-subtle, #edf1f5);
  background: var(--selection-subtle, #f3f8fd);
}

.mActivateOccurrences input[type='checkbox'] {
  width: 16px;
  height: 16px;
  accent-color: var(--action-primary, #1674d1);
}

.cActivateModal__validation {
  margin-top: 9px;
  color: var(--danger-text, #be123c);
  font-size: 12px;
  font-weight: 600;
}

@media (max-width: 680px) {
  .cActivateModal__summaryCard {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .mActivateStats {
    gap: 8px;
  }
}

/* Design-system clubs list */
.clubsDsPage {
  display: block;
  width: 100%;
  min-height: calc(100vh - 88px);
  padding: 0 0 32px;
  background: var(--surface-page, #f6f8fb);
  color: var(--text-body, #243244);
  font-family: var(--font-body, inherit);
}

.clubsDsPage.hasDrawer {
  display: block;
}

.clubsDsMain {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.clubsDsSelectionBar,
.clubsDsFilters {
  border: 1px solid var(--border-subtle, #dbe3ec);
  background: var(--surface-card, #fff);
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
}

.clubsDsHeader {
  display: flex;
  width: calc(100% + 48px);
  min-height: 70px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: -20px 0 0 -24px;
  padding: 0 72px 0 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.clubsDsHeaderTitle {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.clubsDsHeader h1 {
  margin: 0;
  color: var(--text-strong, #142033);
  font-family: var(--font-display, inherit);
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0;
}

.clubsDsHeaderTitle > span {
  display: inline-flex;
  min-width: 24px;
  height: 22px;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 11.5px;
  font-weight: 800;
}

.clubsDsContentCard {
  overflow: visible;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.clubsDsToolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.clubsDsToolbarTitle {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex: 0 0 auto;
}

.clubsDsToolbarTitle strong {
  color: var(--text-strong, #142033);
  font-size: 15px;
  font-weight: 750;
}

.clubsDsToolbarTitle span,
.clubsDsFooter span {
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  font-weight: 600;
}

.clubsDsSearch {
  position: relative;
  flex: 0 1 360px;
  width: min(360px, 100%);
  color: var(--text-subtle, #8a96a8);
}

.clubsDsSearch input,
.clubsDsFilterField select,
.clubsDsDateRange input {
  width: 100%;
  height: 40px;
  border: 1px solid var(--border-default, #cfd8e3);
  border-radius: 10px;
  background: #fff;
  color: var(--text-strong, #142033);
  font: inherit;
  font-size: 13.5px;
  outline: none;
}

.clubsDsSearch input {
  padding: 0 12px;
}

.clubsDsSearch input:focus,
.clubsDsFilterField select:focus,
.clubsDsDateRange input:focus {
  border-color: var(--blue-500, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.14);
}

.clubsDsBtn,
.clubsDsIconTextBtn,
.clubsDsIconBtn,
.clubsDsPager button,
.clubsDsMenuPanel button,
.clubsDsSort {
  font: inherit;
  cursor: pointer;
}

.clubsDsBtn,
.clubsDsIconTextBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 38px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid transparent;
  font-size: 13.5px;
  font-weight: 700;
  white-space: nowrap;
}

.clubsDsBtnPrimary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
  box-shadow: 0 8px 18px rgba(34, 126, 189, 0.22);
}

.clubsDsBtnPrimary:hover:not(:disabled) {
  border-color: var(--action-primary-hover, #1a6da3);
  background: var(--action-primary-hover, #1a6da3);
}

.clubsDsBtnSecondary,
.clubsDsIconTextBtn {
  background: #fff;
  color: var(--text-strong, #142033);
  border-color: var(--border-default, #cfd8e3);
}

.clubsDsBtnGhost {
  background: transparent;
  color: var(--text-muted, #69778a);
  border-color: transparent;
}

.clubsDsBtnDanger {
  background: var(--red-600, #dc2626);
  color: #fff;
  border-color: var(--red-600, #dc2626);
}

.clubsDsSelectionBar {
  display: flex;
  min-height: 0;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
  padding: 8px 14px;
  flex-wrap: wrap;
  border-color: var(--blue-100, #d4e8f6);
  border-radius: var(--radius-md, 8px);
  background: var(--blue-50, #eef6fc);
  box-shadow: none;
  color: var(--blue-700, #155d8c);
  font-size: 13px;
}

.clubsDsSelectionCount {
  margin-right: 4px;
  color: var(--blue-700, #155d8c);
  font-size: 13px;
  font-weight: 600;
}

.clubsDsSelectionBar .clubsDsBtn {
  height: 32px;
  min-height: 32px;
  padding: 0 11px;
  font-size: 13px;
  font-weight: 600;
}

.clubsDsSelectionBar .clubsDsBtnGhost {
  height: auto;
  min-height: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
}

.clubsDsSelectionBar .clubsDsBtnGhost:hover {
  text-decoration: underline;
}

.clubsDsMenu {
  position: relative;
  display: inline-flex;
}

.clubsDsMenuPanel {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 40;
  display: none;
  min-width: 240px;
  padding: 6px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.16);
}

.clubsDsMenuPanel.isRight {
  left: auto;
  right: 0;
}

.clubsDsMenu:hover .clubsDsMenuPanel,
.clubsDsMenu:focus-within .clubsDsMenuPanel {
  display: block;
}

.clubsDsMenuPanel button {
  display: flex;
  width: 100%;
  min-height: 34px;
  align-items: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-body, #243244);
  padding: 8px 10px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
}

.clubsDsMenuPanel button:hover:not(:disabled) {
  background: var(--blue-50, #eaf5fc);
  color: var(--blue-700, #164170);
}

.clubsDsMenuPanel button:disabled {
  cursor: not-allowed;
  color: var(--text-subtle, #9aa6b2);
}

.clubsDsFilters {
  display: grid;
  grid-template-columns: repeat(6, minmax(120px, 1fr)) auto;
  gap: 12px;
  padding: 14px;
}

.clubsDsFilterField span {
  display: block;
  margin-bottom: 6px;
  color: var(--text-muted, #69778a);
  font-size: 12px;
  font-weight: 700;
}

.clubsDsFilterField select {
  padding: 0 10px;
}

.clubsDsDateRange {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.clubsDsDateRange input {
  padding: 0 10px;
}

.clubsDsFilterActions {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.clubsDsTableCard {
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: #fff;
  box-shadow: none;
}

.clubsDsTableScroll {
  overflow: auto;
}

.clubsDsTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 1120px;
}

.clubsDsTable th {
  position: sticky;
  top: 0;
  z-index: 1;
  height: 44px;
  background: var(--slate-25, #f8fafc);
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
  color: var(--text-muted, #69778a);
  padding: 0 12px;
  text-align: left;
  font-size: 11.5px;
  font-weight: 800;
  text-transform: uppercase;
  white-space: nowrap;
}

.clubsDsTable td {
  height: 56px;
  border-bottom: 1px solid var(--border-subtle, #edf1f5);
  color: var(--text-body, #243244);
  padding: 8px 12px;
  font-size: 13px;
  vertical-align: middle;
}

.clubsDsTable tbody tr {
  cursor: pointer;
}

.clubsDsTable tbody tr:hover,
.clubsDsTable tbody tr.isPreview {
  background: var(--blue-50, #eaf5fc);
}

.clubsDsBtnSecondary:hover:not(:disabled),
.clubsDsBtnSecondary:focus-visible,
.clubsDsIconTextBtn:hover,
.clubsDsIconTextBtn:focus-visible {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  outline: none;
}

.clubsDsOpenCell {
  width: 40px;
  min-width: 40px;
  padding-right: 10px !important;
  padding-left: 10px !important;
  text-align: center !important;
}

.clubsDsOpenCell > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-subtle, #94a3b8);
  font-size: 22px;
  line-height: 1;
  opacity: 0;
  transform: translateX(-3px);
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.clubsDsTable tbody tr:hover .clubsDsOpenCell > span,
.clubsDsTable tbody tr.isPreview .clubsDsOpenCell > span {
  opacity: 1;
  transform: translateX(0);
}

.clubsDsCheckCell {
  width: 44px;
  text-align: center !important;
}

.clubsDsCheckCell input {
  width: 16px;
  height: 16px;
  accent-color: var(--blue-600, #227ebd);
}

.clubsDsSort {
  border: 0;
  background: transparent;
  color: inherit;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
  text-transform: inherit;
}

.clubsDsClubCell {
  display: flex;
  align-items: center;
  min-width: 180px;
}

.clubsDsToolbarTitle .clubsDsToolbarCount {
  display: inline-flex;
  min-width: 28px;
  height: 24px;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  border-radius: var(--radius-pill, 999px);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 12px;
  font-weight: 800;
}

.clubsDsClubIcon,
.clubsDsDrawerIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  background: var(--blue-50, #eaf5fc);
  color: var(--blue-700, #164170);
}

.clubsDsClubIcon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
}

.clubsDsClubCell strong,
.clubsDsClubCell small {
  display: block;
}

.clubsDsClubCell strong {
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 750;
}

.clubsDsClubCell small {
  margin-top: 2px;
  color: var(--text-muted, #69778a);
  font-size: 12px;
}

.clubsDsChips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.clubsDsChips span {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 0 8px;
  border-radius: 6px;
  background: var(--slate-100, #edf2f7);
  color: var(--text-body, #243244);
  font-size: 11.5px;
  font-weight: 700;
}

.clubsDsBadge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 24px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

.clubsDsBadge::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.clubsDsBadge.isSuccess {
  background: #eaf7ed;
  color: #217a3a;
}
.clubsDsBadge.isWarning {
  background: #fff4d8;
  color: #9a6500;
}
.clubsDsBadge.isNeutral {
  background: #edf2f7;
  color: #536173;
}

.clubsDsEmpty {
  height: 120px !important;
  text-align: center;
  color: var(--text-muted, #69778a) !important;
}

.clubsDsFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
}

.clubsDsPager {
  display: flex;
  align-items: center;
  gap: 8px;
}

.clubsDsPager button {
  height: 34px;
  border: 1px solid var(--border-default, #cfd8e3);
  border-radius: 9px;
  background: #fff;
  color: var(--text-strong, #142033);
  padding: 0 12px;
  font-size: 13px;
  font-weight: 700;
}

.clubsDsPager button:disabled {
  cursor: not-allowed;
  color: var(--text-subtle, #9aa6b2);
}

.clubsDsDrawerScrim {
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  background: rgba(15, 23, 42, 0.34);
}

.clubsDsDrawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2147483001;
  width: 560px;
  max-width: 94vw;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  box-shadow: -12px 0 42px rgba(15, 23, 42, 0.18);
}

.clubsDsDrawerHeader {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr) 34px;
  gap: 12px;
  align-items: start;
  padding: 18px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.clubsDsDrawerIcon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
}

.clubsDsDrawerHeader h2 {
  margin: 0 0 8px;
  color: var(--text-strong, #142033);
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0;
}

.clubsDsDrawerMeta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  font-weight: 600;
}

.clubsDsDrawerMeta > span:not(:first-child):not(.clubsDsBadge)::before {
  margin-right: 8px;
  color: var(--text-subtle, #9aa6b2);
  content: '·';
}

.clubsDsIconBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 9px;
  background: #fff;
  color: var(--text-muted, #69778a);
}

.clubsDsDrawerTabs {
  display: flex;
  overflow-x: auto;
  gap: 4px;
  padding: 0 14px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.clubsDsDrawerTabs button {
  height: 42px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--text-muted, #69778a);
  font: inherit;
  font-size: 13px;
  font-weight: 750;
  white-space: nowrap;
}

.clubsDsDrawerTabs button.isActive {
  color: var(--blue-700, #164170);
  border-bottom-color: var(--blue-600, #227ebd);
}

.clubsDsDrawerBody {
  flex: 1;
  overflow: auto;
  padding: 16px 18px;
  scrollbar-gutter: stable;
}

.clubsDsDetailsGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 28px;
  gap: 0;
}

.clubsDsDetailsGrid > div {
  display: grid;
  gap: 3px;
  padding: 11px 0;
  border-bottom: 1px solid var(--border-subtle, #edf1f5);
}

.clubsDsDetailsGrid span {
  color: var(--text-muted, #69778a);
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
}

.clubsDsDetailsGrid strong {
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 650;
}

.clubsDsDetailsGrid strong em {
  color: var(--text-muted, #69778a);
  font-style: normal;
  font-weight: 500;
}

.clubDetailList {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 28px;
  margin: 0;
}

.clubDetailList__item {
  display: grid;
  grid-template-columns: minmax(120px, 0.8fr) minmax(0, 1.2fr);
  gap: 14px;
  align-items: baseline;
  padding: 10px 0;
  border-bottom: 1px solid var(--border-subtle, #edf1f5);
}

.clubDetailList__item dt {
  margin: 0;
  color: var(--text-muted, #69778a);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.clubDetailList__item dd {
  margin: 0;
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 650;
  white-space: pre-line;
}

.clubDetailList__item dd.isEmpty {
  color: var(--text-muted, #69778a);
  font-weight: 500;
}

.clubsDsDrawerEmpty {
  display: grid;
  min-height: 260px;
  align-content: center;
  justify-items: center;
  gap: 6px;
  padding: 28px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  color: var(--text-muted, #69778a);
  text-align: center;
}

.clubsDsDrawerEmpty__icon {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  border-radius: 12px;
  background: var(--blue-50, #eef8ff);
  color: var(--blue-700, #17659a);
}

.clubsDsDrawerEmpty .clubsDsBtn {
  margin-top: 10px;
}

.clubsDsDrawerEmpty strong {
  color: var(--text-strong, #142033);
  font-size: 15px;
}

.clubsDsParticipantsList {
  display: flex;
  flex-direction: column;
}
.clubsDsParticipantActions {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 12px;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--border-subtle, #edf1f5);
}
.clubsDsParticipant {
  display: grid;
  min-height: 58px;
  grid-template-columns: 28px 36px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
  padding: 9px 2px;
  border-bottom: 1px solid var(--border-subtle, #edf1f5);
}
.clubsDsParticipantAvatar {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--blue-50, #eef8ff);
  color: var(--blue-700, #17659a);
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
}
.clubsDsParticipantCopy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}
.clubsDsParticipantCopy strong {
  overflow: hidden;
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.clubsDsParticipantCopy small {
  color: var(--text-muted, #69778a);
  font-size: 11.5px;
}
.clubsDsParticipantNumber {
  display: inline-flex;
  min-width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 10.5px;
  font-weight: 750;
}

.clubsDsEventsTab {
  display: grid;
  gap: 14px;
}

.clubsDsEventStats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.clubsDsEventStats > div {
  display: grid;
  min-width: 0;
  gap: 5px;
  padding: 12px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  background: var(--surface-subtle, #f8fafc);
}

.clubsDsEventStats span {
  overflow: hidden;
  color: var(--text-muted, #69778a);
  font-size: 10.5px;
  font-weight: 750;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clubsDsEventStats strong {
  color: var(--text-strong, #142033);
  font-size: 21px;
  font-weight: 850;
}

.clubsDsEventStats .isUpcoming {
  border-color: var(--blue-200, #bfdbfe);
  background: var(--blue-50, #eff6ff);
}

.clubsDsEventStats .isUpcoming strong {
  color: var(--blue-700, #155d8c);
}

.clubsDsEventStats .isPast strong {
  color: var(--text-muted, #64748b);
}

.clubsDsEventStats .isCancelled strong {
  color: var(--red-700, #b42318);
}

.clubsDsEventInsight {
  display: grid;
  gap: 4px;
  padding: 14px 16px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 11px;
  background: var(--surface-card, #fff);
}

.clubsDsEventInsight strong {
  color: var(--text-strong, #142033);
  font-size: 13.5px;
  font-weight: 800;
}

.clubsDsEventInsight span {
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  line-height: 1.45;
}

.clubsDsInvitationsTab {
  display: grid;
  gap: 16px;
}

.clubsDsInvitationIntro,
.clubsDsInvitationBookings {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: #fff;
}

.clubsDsInvitationIntro > div,
.clubsDsInvitationBookings > div,
.clubsDsInvitationNotice {
  display: grid;
  gap: 5px;
}

.clubsDsInvitationIntro strong,
.clubsDsInvitationBookings strong,
.clubsDsInvitationNotice strong {
  color: var(--text-strong, #142033);
  font-size: 14px;
  font-weight: 800;
}

.clubsDsInvitationIntro span,
.clubsDsInvitationBookings span,
.clubsDsInvitationNotice span {
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  line-height: 1.5;
}

.clubsDsInvitationStats {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
}

.clubsDsInvitationStats > div {
  display: grid;
  gap: 6px;
  min-width: 0;
  padding: 13px 12px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  background: var(--surface-subtle, #f8fafc);
}

.clubsDsInvitationStats span {
  color: var(--text-muted, #69778a);
  font-size: 10.5px;
  font-weight: 750;
  line-height: 1.25;
}

.clubsDsInvitationStats strong {
  color: var(--text-strong, #142033);
  font-size: 22px;
  font-weight: 850;
}

.clubsDsInvitationStats .isAccepted strong {
  color: var(--green-700, #15803d);
}

.clubsDsInvitationStats .isRejected strong {
  color: var(--red-700, #b42318);
}

.clubsDsInvitationNotice {
  padding: 14px 16px;
  border: 1px solid var(--blue-200, #bfdbfe);
  border-radius: 12px;
  background: var(--blue-50, #eff6ff);
}

@media (max-width: 860px) {
  .clubsDsEventStats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .clubsDsInvitationStats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .clubsDsInvitationIntro,
  .clubsDsInvitationBookings {
    align-items: stretch;
    flex-direction: column;
  }
}

.clubBookingResponseDrawer {
  width: min(760px, calc(100vw - 24px));
}

.clubBookingResponseMeta {
  margin-bottom: 22px;
}

.clubBookingResponseAnswers {
  padding: 18px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: #fff;
}

.clubBookingResponseAnswers h3 {
  margin: 0 0 16px;
  color: var(--text-strong, #142033);
  font-size: 15px;
  font-weight: 800;
}

.clubsDsBadge.isInfo {
  border-color: var(--blue-200, #bfdbfe);
  background: var(--blue-50, #eff6ff);
  color: var(--blue-700, #155d8c);
}

.clubsDsBadge.isWarning {
  border-color: #fedf89;
  background: #fffaeb;
  color: #b54708;
}

.clubsDsDrawerFooter {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
  padding: 14px 16px;
  border-top: 1px solid var(--border-subtle, #dbe3ec);
  background: var(--slate-25, #f8fafc);
}

@media (max-width: 1180px) {
  .clubsDsPage.hasDrawer {
    grid-template-columns: 1fr;
  }

  .clubsDsFilters {
    grid-template-columns: repeat(2, minmax(140px, 1fr));
  }
}

@media (max-width: 1217px) {
  .clubsDsHeader {
    width: 100vw;
    margin-left: -12px;
    padding-right: 28px;
  }
}

@media (max-width: 720px) {
  .clubsDsDetailsGrid,
  .clubDetailList {
    grid-template-columns: 1fr;
  }

  .clubsDsPage {
    padding: 0 0 20px;
  }

  .clubsDsHeader,
  .clubsDsToolbar,
  .clubsDsSelectionBar,
  .clubsDsFooter {
    align-items: stretch;
    flex-direction: column;
  }

  .clubsDsHeader {
    min-height: 64px;
    align-items: center;
    flex-direction: row;
    padding: 0 16px;
  }

  .clubsDsContentCard {
    margin: 0 12px;
  }

  .clubsDsFooter {
    align-items: center;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
  }

  .clubsDsSearch {
    width: 100%;
  }

  .clubsDsFilters {
    grid-template-columns: 1fr;
  }
}

.clubsDsIconTextBtn.isActive {
  border-color: var(--action-primary, #227ebd);
  color: var(--blue-700, #155d8c);
  background: var(--blue-50, #eef7fd);
}

.clubsDsColumns {
  position: relative;
  display: inline-flex;
}

.clubsDsBtnBadge {
  min-width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--surface-muted, #edf2f7);
  color: var(--text-muted, #536173);
  font-size: 11px;
  font-weight: 800;
}

.clubsDsColumnsMenu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 35;
  width: 252px;
  padding: 8px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);
}

.clubsDsColumnsHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 8px 9px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.clubsDsColumnsHead button {
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  text-transform: none;
  letter-spacing: 0;
}

.clubsDsColumnsItem {
  min-height: 34px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 8px;
  border-radius: 6px;
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.clubsDsColumnsItem:hover {
  background: var(--surface-hover, #f8fafc);
}

.clubsDsColumnsItem input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--action-primary, #227ebd);
}

.clubsDsColumnsItem.isLocked {
  color: var(--text-subtle, #94a3b8);
  cursor: default;
}

.clubsDsFilterFieldWide {
  grid-column: span 2;
}

.clubsDsFilterChips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 40px;
  padding: 3px;
}

.clubsDsFilterChip {
  min-height: 32px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  padding: 0 11px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.clubsDsFilterChip:hover {
  border-color: var(--border-brand, #6fb1df);
  color: var(--blue-700, #155d8c);
}

.clubsDsFilterChip.isSelected {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.clubsDsFooter {
  justify-content: flex-end;
  margin-top: 0;
  padding: 12px 16px;
  border: 0;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 0 0 11px 11px;
  background: var(--surface-card, #fff);
  box-shadow: none;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}

.clubsDsPaginationSummary {
  margin-right: 4px;
}

.clubsDsPaginationEllipsis {
  min-width: 18px;
  text-align: center;
  color: var(--text-subtle, #94a3b8);
}

.clubsDsPageBtn,
.clubsDsPagerBtn {
  min-width: 34px;
  height: 34px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  padding: 0 12px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.clubsDsPageBtn:hover,
.clubsDsPagerBtn:hover:not(:disabled) {
  border-color: var(--border-brand, #6fb1df);
  color: var(--blue-700, #155d8c);
}

.clubsDsPageBtn.isActive {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.clubsDsPagerBtn:disabled {
  cursor: default;
  color: var(--text-subtle, #94a3b8);
}

@media (max-width: 720px) {
  .clubsDsFilterFieldWide {
    grid-column: auto;
  }

  .clubsDsColumnsMenu {
    left: 0;
    right: auto;
    width: min(252px, 90vw);
  }
}

.clubsDsDateRange .sit-dp,
.clubsDsDateRange .sit-dp__pop {
  z-index: 10000;
}

.clubsDsDateRange .sit-dp__pop {
  position: fixed;
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  transform: translate(-50%, -50%);
  overflow: hidden;
  overscroll-behavior: contain;
  align-items: stretch;
  animation: none;
}

.clubsDsDateRange .sit-dp__pop > div:last-child {
  min-width: 0;
  min-height: 0;
  max-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
}

.clubsDsDateRange .sit-dp__pop > div:last-child > div:first-child {
  min-height: 0;
  overflow: auto;
  overscroll-behavior: contain;
}

/* List filters handoff: right-side drawer for the large, control-heavy filter set. */
.clubsDsFilterAnchor {
  position: static;
  flex: 0 0 auto;
}

.clubsRoute {
  margin-top: 0 !important;
}

.clubsDsFilterScrim {
  position: fixed;
  z-index: 1055;
  inset: 0;
  width: 100vw;
  height: 100vh;
  padding: 0;
  border: 0;
  background: rgba(15, 23, 42, 0.28);
  cursor: default;
}

.clubsDsFilterAnchor .clubsDsFilters {
  position: fixed;
  z-index: 1060;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  display: flex;
  width: 360px;
  max-width: calc(100vw - 20px);
  height: auto;
  max-height: none;
  flex-direction: column;
  gap: 0;
  padding: 0;
  overflow: hidden;
  border: 0;
  border-left: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 0;
  background: #fff;
  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);
}

.clubsDsFilterHead {
  display: flex;
  min-height: 34px;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 15px 18px;
  border-bottom: 1px solid var(--border-subtle, #e7edf3);
}

.clubsDsFilterHead strong {
  color: var(--text-strong, #172b4d);
  font-size: 16px;
  font-weight: 800;
}

.clubsDsFilterHead .clubsDsFilterClose {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-muted, #667085);
  font-size: 22px;
  line-height: 1;
  font-weight: 400;
  cursor: pointer;
}

.clubsDsFilterHead .clubsDsFilterClose:hover {
  background: var(--surface-hover, #f2f4f7);
  color: var(--text-strong, #172b4d);
}

.clubsDsFilterBody {
  display: grid;
  flex: 1 1 auto;
  min-height: 0;
  grid-template-columns: 1fr;
  gap: 16px;
  padding: 16px 18px 22px;
  overflow-y: auto;
}

.clubsDsFilterBody .clubsDsFilterFieldWide {
  grid-column: auto;
}

.clubsDsFilterBody .clubsDsFilterField > span {
  margin-bottom: 7px;
  color: #475467;
  font-size: 12px;
  font-weight: 750;
}

.clubsDsFilterBody .clubsDsFilterField select,
.clubsDsFilterBody .sit-dp__trigger {
  width: 100%;
  height: 38px;
  min-height: 38px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background-color: #fff;
  font-size: 13px;
}

.clubsDsFilterBody .clubsDsDateRange {
  display: block;
  width: 100%;
}

.clubsDsFilterBody .clubsDsFilterChips {
  gap: 7px;
  min-height: 0;
  padding: 0;
}

.clubsDsFilterBody .clubsDsFilterChip {
  min-height: 32px;
  border-radius: 999px;
  padding: 0 11px;
  font-size: 12px;
  font-weight: 650;
}

.clubsDsFilterAnchor .clubsDsFilterActions {
  min-height: 64px;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 18px;
  border-top: 1px solid var(--border-subtle, #e7edf3);
  background: #fff;
}

.clubsDsFilterAnchor .clubsDsFilterActions .clubsDsBtn {
  height: 38px;
  min-height: 38px;
}

.clubsDsActiveFilters {
  display: flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 16px;
  border: 0;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 0;
  background: #fff;
}

.clubsDsActiveFilters button {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid var(--blue-200, #b9dff2);
  border-radius: 999px;
  background: var(--blue-50, #eef8fc);
  color: var(--blue-800, #124f76);
  font-size: 12px;
  font-weight: 650;
}

.clubsDsActiveFilters button:hover {
  border-color: var(--blue-400, #5aaed6);
  background: #e3f3fb;
}

.modal-dialog.modal-xl.clubsReportsModal {
  width: min(540px, calc(100vw - 32px)) !important;
  min-width: 0 !important;
  max-width: 540px !important;
  overflow: visible !important;
}
.clubsReportsModal .modal-content {
  display: flex;
  height: auto;
  max-height: calc(100vh - 48px);
  flex-direction: column;
  overflow: hidden !important;
  border: 0;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);
}
.clubsReportsModal .modal-header {
  flex: 0 0 auto;
}
.clubsReportsModal .modal-body {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 0 !important;
  overflow: hidden !important;
}
.clubsReportsModal__intro {
  flex: 0 0 auto;
  padding: 11px 18px;
  border-bottom: 1px solid var(--border-subtle, #e5eaf0);
  background: var(--slate-25, #f8fafc);
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  line-height: 1.4;
}
.clubsReportsModal__group {
  min-height: 0;
  max-height: min(520px, calc(100vh - 168px));
  flex: 0 1 auto;
  padding: 13px 18px 16px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}
.clubsReportsModal__group h3 {
  margin: 0 0 10px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.055em;
  text-transform: uppercase;
}
.clubsReportsModal__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.clubsReportsModal__list > button {
  display: grid;
  min-height: 58px;
  grid-template-columns: 32px minmax(0, 1fr) 16px;
  align-items: center;
  gap: 10px;
  padding: 8px 11px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 9px;
  background: #fff;
  color: var(--text-body, #334155);
  text-align: left;
  cursor: pointer;
}
.clubsReportsModal__list > button:hover {
  border-color: var(--blue-300, #9bc9e7);
  background: #f8fcff;
}
.clubsReportsModal__icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--blue-50, #eaf4fb);
  color: var(--blue-600, #227ebd);
}
.clubsReportsModal__icon svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}
.clubsReportsModal__copy,
.clubsReportsModal__heading {
  display: flex;
  min-width: 0;
}
.clubsReportsModal__copy {
  flex-direction: column;
  gap: 2px;
}
.clubsReportsModal__heading {
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.clubsReportsModal__heading strong {
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 750;
}
.clubsReportsModal__format {
  padding: 3px 7px;
  border-radius: 999px;
  background: var(--slate-100, #edf2f7);
  color: var(--text-muted, #64748b);
  font-size: 10.5px;
  font-weight: 750;
}
.clubsReportsModal__copy small {
  color: var(--text-muted, #69778a);
  font-size: 11px;
  line-height: 1.3;
}
.clubsReportsModal__arrow {
  color: #94a3b8;
  font-size: 24px;
  line-height: 1;
}

.clubsReportParametersModal.modal-dialog {
  width: min(680px, calc(100vw - 32px));
  max-width: 680px;
  height: min(760px, calc(100vh - 48px));
}
.clubsReportParametersModal .modal-content {
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);
}
.clubsReportParametersModal:has(.clubAttendanceReportForm) {
  height: min(720px, calc(100vh - 48px));
}
.clubsReportParametersModal:has(.clubAttendanceReportForm) .modal-content {
  height: 100%;
}
.clubsReportParametersModal:has(.compactClubReportForm) {
  height: min(640px, calc(100vh - 48px));
}
.clubsReportParametersModal:has(.compactClubReportForm) .modal-content {
  height: 100%;
}
.clubsReportParametersModal__body > form.compactClubReportForm {
  height: 100%;
  min-height: 0;
  flex: 1 1 0;
  overflow: hidden;
}
.clubsReportParametersModal__body > form.clubAttendanceReportForm {
  height: 100%;
  min-height: 0;
  flex: 1 1 0;
  overflow: hidden;
}
.clubAttendanceReportForm .eReportDescription {
  margin-bottom: 14px;
}
.clubAttendanceReportForm .eReportSection {
  margin-top: 0;
  padding-top: 0;
}
.clubAttendanceReportForm .eReportSection + .eReportSection {
  margin-top: 16px;
}
.clubAttendanceReportForm .eReportActions {
  position: sticky;
  z-index: 3;
  bottom: 0;
  margin-top: 0;
}
.clubsReportParametersModal .modal-header {
  min-height: 76px;
  flex: 0 0 auto;
  padding: 14px 18px;
  border-bottom: 1px solid var(--border-subtle, #e3e8ef);
  background: #fff;
}
.clubsReportModalTitle {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}
.clubsReportModalTitle__icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: var(--blue-50, #eef8ff);
  color: var(--blue-700, #17659a);
}
.clubsReportModalTitle__icon svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.9;
}
.clubsReportModalTitle--compact {
  gap: 9px;
}
.clubsReportModalTitle--compact .clubsReportModalTitle__icon {
  width: 20px;
  height: 20px;
  flex-basis: 20px;
  border-radius: 0;
  background: transparent;
  color: var(--text-muted, #64748b);
}
.clubsReportModalTitle--compact .clubsReportModalTitle__icon svg {
  width: 17px;
  height: 17px;
}
.clubsReportModalTitle > span:last-child {
  display: flex;
  min-width: 0;
  flex-direction: column;
}
.clubsReportModalTitle strong {
  color: var(--text-strong, #142033);
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
}
.clubsReportModalTitle small {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
}
.clubsReportParametersModal .modal-body,
.clubsReportParametersModal__body {
  display: flex;
  min-height: 0;
  flex-direction: column;
  padding: 0 !important;
  overflow: hidden !important;
}
.clubsReportParametersModal__body > form {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
  flex-wrap: wrap;
  align-content: flex-start;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  color: var(--text-body, #334155);
  font-size: 13px;
}
.clubsReportParametersModal__body > form.eReportForm {
  display: flex !important;
  min-height: 0;
  flex: 1 1 0;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: normal;
  overflow: hidden;
}
.clubsReportParametersModal__body > form.eReportForm > .eReportForm__scroll {
  min-height: 0;
  flex: 1 1 0;
  padding-right: 8px;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-gutter: stable;
}
.clubsReportParametersModal__body > form.eReportForm > .eReportActions {
  flex: 0 0 auto;
  margin-top: 0;
}
.clubsReportParametersModal__body .bReportFormTitle {
  display: none;
}
.clubsReportParametersModal__body > form > .mb-3.mt-3,
.clubsReportParametersModal__body .bReportFormTitle + .mb-3 {
  width: calc(100% - 48px);
  margin: 18px 24px 8px !important;
  padding: 14px 16px;
  border: 1px solid var(--border-subtle, #e3e8ef);
  border-radius: 11px;
  background: var(--slate-25, #f8fafc);
  color: var(--text-body, #334155);
  line-height: 1.55;
}
.clubsReportParametersModal__body .form-group,
.clubsReportParametersModal__body > form > .form-check,
.clubsReportParametersModal__body > form > .mt-3.mb-3 {
  box-sizing: border-box;
  width: calc(100% - 48px);
  margin: 7px 24px !important;
  padding: 12px 14px;
  border: 1px solid var(--border-subtle, #e3e8ef);
  border-radius: 11px;
  background: #fff;
}
.clubsReportParametersModal__body .form-group > label:first-child,
.clubsReportParametersModal__body .form-check-label {
  margin-bottom: 7px;
  color: var(--text-strong, #142033);
  font-size: 12.5px;
  font-weight: 700;
}
.clubsReportParametersModal__body .form-group > .d-flex,
.clubsReportParametersModal__body .form-check > .d-flex {
  align-items: center;
}
.clubsReportParametersModal__body .sit-switch {
  flex: 0 0 auto;
  margin: 0;
}
.clubsReportParametersModal__body .form-control {
  width: 100%;
  min-height: 40px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 9px;
  background: #fff;
  color: var(--text-strong, #142033);
  font-size: 13px;
  box-shadow: none;
}
.clubsReportParametersModal__body .form-control:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}
.clubsReportParametersModal__body .react-datepicker-wrapper,
.clubsReportParametersModal__body .react-datepicker__input-container {
  width: 100%;
}
.clubsReportParametersModal__body .react-datepicker-popper,
.clubsReportParametersModal__body .sit-dp__pop {
  z-index: 1200;
}
.clubsReportParametersModal__body input[type='radio'],
.clubsReportParametersModal__body input[type='checkbox'] {
  accent-color: var(--blue-600, #227ebd);
}
.clubsReportParametersModal__body .eMultiSelectCheckboxes > div {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  columns: auto !important;
}
.clubsReportParametersModal__body .eMultiSelectCheckbox {
  position: relative;
  display: inline-flex;
  margin: 0;
  padding: 0;
  break-inside: avoid;
}
.clubsReportParametersModal__body .eMultiSelectCheckbox input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}
.clubsReportParametersModal__body .eMultiSelectCheckbox label {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  margin: 0;
  padding: 5px 10px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: #fff;
  color: var(--text-body, #475569);
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}
.clubsReportParametersModal__body .eMultiSelectCheckbox input:checked + label {
  border-color: var(--blue-600, #227ebd);
  background: var(--blue-600, #227ebd);
  color: #fff;
}
.clubsReportParametersModal__body .form-group:has(+ .form-group .clubReportDateRange) {
  display: none;
}
.clubsReportParametersModal__body .form-group:has(.clubReportDateRange) > label {
  display: none;
}
.clubsReportParametersModal__body .form-group:has(.clubReportDateRange)::before {
  display: block;
  margin-bottom: 8px;
  color: var(--text-strong, #142033);
  content: 'Reporting period';
  font-size: 12.5px;
  font-weight: 700;
}
.clubsReportParametersModal__body .clubReportDateRange,
.clubsReportParametersModal__body .clubReportSingleDate,
.clubsReportParametersModal__body .sit-dp {
  width: 100%;
}
.clubsReportParametersModal__body .clubReportDateRange .sit-dp__pop {
  position: fixed;
  z-index: 1300;
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  width: max-content;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  transform: translate(-50%, -50%);
  overflow: auto;
}
.clubsReportParametersModal__body .form-group > .d-flex {
  min-height: 44px;
  flex-direction: row-reverse;
  justify-content: space-between;
  gap: 16px;
}
.clubsReportParametersModal__body .form-group > .d-flex > .d-flex,
.clubsReportParametersModal__body .form-check > .d-flex > .d-flex {
  min-width: 0;
  flex: 1 1 auto;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: flex-start !important;
  gap: 4px 8px;
}
.clubsReportParametersModal__body .form-group > .d-flex > .d-flex > label,
.clubsReportParametersModal__body .form-check > .d-flex > .d-flex > label {
  margin: 0;
}
.clubsReportParametersModal__body .eFieldInlineHint {
  width: 100%;
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
  font-weight: 400;
  line-height: 1.35;
}
.clubsReportParametersModal__body .form-group > .d-flex > .d-flex > .ml-3,
.clubsReportParametersModal__body .form-check > .d-flex > .d-flex > .ml-3 {
  display: none !important;
}
.clubsReportParametersModal__body .sit-switch {
  flex: 0 0 auto;
}
.clubsReportParametersModal__body .sit-switch__track {
  width: 38px;
  height: 22px;
}
.clubsReportParametersModal__body .sit-switch__thumb {
  width: 18px;
  height: 18px;
}
.clubsReportParametersModal__body form > .btn {
  min-height: 40px;
  order: 98;
  margin-top: 16px !important;
  margin-bottom: 16px !important;
  padding: 0 16px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
}
.clubsReportParametersModal__body form > .btn-secondary {
  margin-right: 8px !important;
  margin-left: 24px !important;
  border-color: var(--border-default, #cbd5e1);
  background: #fff;
  color: var(--text-body, #334155);
}
.clubsReportParametersModal__body form > .btn-primary {
  order: 99;
  margin-right: 24px !important;
  margin-left: auto !important;
  border-color: var(--blue-600, #227ebd);
  background: var(--blue-600, #227ebd);
  color: #fff;
}

.averageClubAttendanceForm {
  display: flex !important;
  width: 100%;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  flex-wrap: nowrap !important;
  align-content: normal !important;
  margin: 0;
  overflow: hidden !important;
  background: #fff;
}
.averageClubAttendanceForm__scroll {
  min-height: 0;
  flex: 1 1 auto;
  padding: 0 8px 0 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-gutter: stable;
}
.averageClubAttendanceForm__customRange {
  margin-top: 14px;
}
.averageClubAttendanceForm .eReportActions {
  flex: 0 0 auto;
  margin-top: 0;
}
.averageClubAttendanceForm .sit-rf__periods {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.averageClubAttendanceForm .sit-rf__period {
  min-height: 42px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
}
.averageClubAttendanceForm .sit-rf__chips {
  gap: 7px;
}
.averageClubAttendanceForm .sit-rf__chip {
  min-height: 32px;
  padding: 5px 11px;
  font-size: 12px;
}

@media (max-width: 560px) {
  .clubsReportParametersModal.modal-dialog {
    width: calc(100vw - 20px);
    height: calc(100vh - 24px);
  }
  .clubsReportParametersModal__body > form > .mb-3.mt-3,
  .clubsReportParametersModal__body .bReportFormTitle + .mb-3,
  .clubsReportParametersModal__body .form-group,
  .clubsReportParametersModal__body > form > .form-check,
  .clubsReportParametersModal__body > form > .mt-3.mb-3 {
    width: calc(100% - 28px);
    margin-right: 14px !important;
    margin-left: 14px !important;
  }
  .clubsReportParametersModal__body .clubReportDateRange .sit-cal__panes {
    flex-direction: column;
  }
  .averageClubAttendanceForm__scroll {
    padding-right: 6px;
  }
  .averageClubAttendanceForm .sit-rf__periods {
    grid-template-columns: 1fr;
  }
}

.clubsDsActiveFilters button.isClear {
  border-color: transparent;
  background: transparent;
  color: var(--text-muted, #69778a);
}

@media (max-width: 760px) {
  .clubsDsFilterAnchor {
    position: static;
  }

  .clubsDsFilterAnchor .clubsDsFilters {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100vw;
    max-width: none;
    height: 100vh;
    max-height: none;
    border-radius: 0;
  }

  .clubsDsFilterBody {
    grid-template-columns: 1fr;
  }
}

.clubsDsDateRange .sit-dp__pop > div:last-child > div:last-child {
  flex: 0 0 auto;
  padding: 0 14px 14px !important;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
  box-shadow: 0 -8px 16px rgba(15, 23, 42, 0.08);
}

.clubsDsDateRange .sit-cal__foot {
  position: static;
  margin: 0;
  padding-top: 12px;
}
.clubsInviteMultiWarning {
  width: min(680px, 100%);
  margin: 20px 0;
  padding: 20px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 14px;
  background: #fff;
}

.clubsInviteMultiWarning__banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  border: 1px solid #f1dfb7;
  border-radius: 10px;
  background: #fffaf0;
}

.clubsInviteMultiWarning__banner > span {
  display: inline-flex;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eda83b;
  color: #fff;
  font-weight: 800;
}

.clubsInviteMultiWarning__banner strong {
  color: var(--text-strong, #142033);
  font-size: 14px;
}

.clubsInviteMultiWarning__banner p {
  margin: 4px 0 0;
  color: var(--text-muted, #69778a);
  font-size: 12.5px;
  line-height: 1.5;
}

.clubsInviteMultiWarning__clubs {
  margin-top: 16px;
  border-top: 1px solid var(--border-subtle, #e3e8ef);
}

.clubsInviteMultiWarning__clubs > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 11px 2px;
  border-bottom: 1px solid var(--border-subtle, #e3e8ef);
}

.clubsInviteMultiWarning__clubs strong {
  color: var(--text-strong, #142033);
  font-size: 13px;
}

.clubsInviteMultiWarning__clubs span {
  color: var(--text-muted, #69778a);
  font-size: 12px;
}

.clubsInviteMultiWarning__actions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin-top: 18px;
}
.clubsInviteConfirmModal .modal-body {
  padding: 20px 22px !important;
  background: #fff;
}

.clubsInviteConfirmModal .modal-content {
  border: 1px solid var(--border-subtle, #dbe3ec) !important;
  border-radius: 14px !important;
  box-shadow: 0 20px 54px rgba(15, 23, 42, 0.2) !important;
}

.clubsInviteConfirmModal .modal-header {
  min-height: 64px;
  align-items: center;
  padding: 17px 22px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
}

.clubsInviteConfirmModal .modal-title {
  color: var(--text-strong, #142033);
  font-size: 18px;
  font-weight: 760;
}

.clubsInviteConfirmModal .modal-header .close {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border-radius: 8px;
  color: var(--text-muted, #69778a);
  opacity: 1;
}

.clubsInviteConfirmModal .modal-footer {
  gap: 9px;
  padding: 14px 22px;
  border-top: 1px solid var(--border-subtle, #dbe3ec);
}

.clubsInviteConfirmModal .modal-footer button {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border-radius: 9px;
  font-size: 12.5px;
  font-weight: 750;
}

.clubsInviteConfirmModal .modal-footer button:first-child {
  border: 1px solid var(--border-default, #cbd5e1);
  background: #fff;
  color: var(--text-body, #334155);
}

.clubsInviteConfirmModal .modal-footer button:last-child {
  border: 1px solid var(--blue-600, #227ebd);
  background: var(--blue-600, #227ebd);
  color: #fff;
}

.clubsInviteConfirm__banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 13px;
  border: 1px solid var(--blue-200, #cce5f5);
  border-radius: 10px;
  background: var(--blue-50, #eef8fd);
}

.clubsInviteConfirm__banner > span {
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  color: var(--blue-700, #18699f);
}

.clubsInviteConfirm__banner > span svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.clubsInviteConfirm__banner p {
  margin: 2px 0 0;
  color: var(--text-body, #334155);
  font-size: 12.5px;
  line-height: 1.45;
}

.clubsInviteConfirm__clubs {
  display: grid;
  gap: 10px;
  margin-top: 14px;
}

.clubsInviteConfirm__club {
  padding: 14px 16px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  background: #fff;
}

.clubsInviteConfirm__club > strong {
  color: var(--text-strong, #142033);
  font-size: 14px;
  font-weight: 760;
}

.clubsInviteConfirm__club dl {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin: 10px 0 0;
}

.clubsInviteConfirm__club dl > div {
  min-width: 0;
}

.clubsInviteConfirm__club dt {
  color: var(--text-muted, #69778a);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.clubsInviteConfirm__club dd {
  margin: 3px 0 0;
  color: var(--text-strong, #142033);
  font-size: 12.5px;
}

.clubsInviteConfirm__deadline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 14px;
  padding-top: 13px;
  border-top: 1px solid var(--border-subtle, #dbe3ec);
  font-size: 12.5px;
}

.clubBookingForm .SendTimeFormEditor {
  margin-top: 0;
}

.clubBookingForm .SendTimeFormEditor__header {
  border-radius: 12px;
}

.clubBookingForm .SendTimeFormEditor__beforeActions {
  padding: 14px 16px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 12px;
  background: #fff;
}

.clubBookingForm .SendTimeFormEditor__footer {
  align-items: center;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--border-subtle, #dbe3ec);
}

.clubsInvitationExitModal .modal-content {
  border: 1px solid var(--border-subtle, #dbe3ec) !important;
  border-radius: 14px !important;
  box-shadow: 0 20px 54px rgba(15, 23, 42, 0.2) !important;
}

.clubsInvitationExitModal .modal-header {
  min-height: 64px;
  padding: 17px 20px !important;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec) !important;
  background: #fff !important;
}

.clubsInvitationExitModal .modal-title {
  color: var(--text-strong, #142033) !important;
  font-size: 17px !important;
  font-weight: 760 !important;
}

.clubsInvitationExitModal .modal-header button {
  width: 34px !important;
  height: 34px !important;
  border: 0 !important;
  border-radius: 8px !important;
  background: transparent !important;
  color: var(--text-muted, #69778a) !important;
}

.clubsInvitationExitModal .modal-body {
  padding: 20px !important;
  color: var(--text-body, #334155) !important;
  font-size: 13px !important;
  line-height: 1.5 !important;
}

.clubsInvitationExitModal__body {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.clubsInvitationExitModal__icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  border: 1px solid #fed7aa;
  border-radius: 11px;
  background: #fff7ed;
  color: #c2410c;
}

.clubsInvitationExitModal__icon svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.clubsInvitationExitModal__copy {
  min-width: 0;
  padding-top: 1px;
}

.clubsInvitationExitModal__copy strong {
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 760;
}

.clubsInvitationExitModal__copy p {
  margin: 5px 0 0;
  color: var(--text-muted, #69778a);
  font-size: 13px;
  line-height: 1.5;
}

.clubsInvitationExitModal .modal-footer {
  gap: 9px !important;
  padding: 14px 20px !important;
  border-top: 1px solid var(--border-subtle, #dbe3ec) !important;
  background: #fff !important;
}

.clubsInvitationExitModal .modal-footer button {
  min-height: 38px;
  padding: 0 15px !important;
  border-radius: 9px !important;
  font-size: 12.5px;
  font-weight: 750;
}

.clubsInvitationExitModal .modal-footer .btn-secondary {
  border: 1px solid var(--border-default, #cbd5e1) !important;
  background: #fff !important;
  color: var(--text-body, #334155) !important;
}

.clubsInvitationExitModal .modal-footer .btn-primary {
  border: 1px solid #dc2626 !important;
  background: #dc2626 !important;
  color: #fff !important;
}

.clubsInvitationExitModal .modal-footer .btn-primary:hover,
.clubsInvitationExitModal .modal-footer .btn-primary:focus {
  border-color: #b91c1c !important;
  background: #b91c1c !important;
  color: #fff !important;
}

.clubsDeleteModal .modal-content {
  border: 1px solid var(--border-subtle, #dbe3ec) !important;
  border-radius: 14px !important;
  box-shadow: 0 20px 54px rgba(15, 23, 42, 0.2) !important;
}

.clubsDeleteModal .modal-header {
  min-height: 64px;
  padding: 17px 20px !important;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec) !important;
  background: #fff !important;
}

.clubsDeleteModal .modal-title {
  color: var(--text-strong, #142033) !important;
  font-size: 17px !important;
  font-weight: 760 !important;
}

.clubsDeleteModal .modal-header button {
  width: 34px !important;
  height: 34px !important;
  border: 0 !important;
  border-radius: 8px !important;
  background: transparent !important;
  color: var(--text-muted, #69778a) !important;
}

.clubsDeleteModal .modal-body {
  padding: 20px !important;
}

.clubsDeleteModal__body {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.clubsDeleteModal__icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  align-items: center;
  justify-content: center;
  border: 1px solid #fecdd3;
  border-radius: 11px;
  background: #fff1f2;
  color: #be123c;
}

.clubsDeleteModal__icon svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.clubsDeleteModal__copy {
  min-width: 0;
  padding-top: 1px;
}

.clubsDeleteModal__copy strong {
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 760;
}

.clubsDeleteModal__copy p {
  margin: 5px 0 0;
  color: var(--text-muted, #69778a);
  font-size: 13px;
  line-height: 1.5;
}

.clubsDeleteModal .modal-footer {
  gap: 9px !important;
  padding: 14px 20px !important;
  border-top: 1px solid var(--border-subtle, #dbe3ec) !important;
  background: #fff !important;
}

.clubsDeleteModal .modal-footer button {
  min-height: 38px;
  padding: 0 15px !important;
  border-radius: 9px !important;
  font-size: 12.5px;
  font-weight: 750;
}

.clubsDeleteModal .modal-footer .btn-secondary {
  border: 1px solid var(--border-default, #cbd5e1) !important;
  background: #fff !important;
  color: var(--text-body, #334155) !important;
}

.clubsDeleteModal .modal-footer .btn-primary {
  border: 1px solid #be123c !important;
  background: #be123c !important;
  color: #fff !important;
}

.clubsDeleteModal .modal-footer .btn-primary:hover {
  border-color: #9f1239 !important;
  background: #9f1239 !important;
}

.clubsInviteConfirm__deadline span {
  color: var(--text-muted, #69778a);
}

.clubsInviteConfirm__error,
.clubsInviteConfirm__warning {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 12px;
}

.clubsInviteConfirm__error {
  background: var(--red-50, #fff1f2);
  color: var(--red-700, #b42335);
}

.clubsInviteConfirm__warning {
  background: #fffaf0;
  color: #8a5700;
}

/* Unified Clubs modal shell */
.clubsModal.modal-dialog {
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.clubsModal .modal-content {
  max-height: calc(100vh - 48px) !important;
  border: 0 !important;
  border-radius: 14px !important;
  background: var(--surface-card, #fff) !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.24) !important;
}

.clubsModal .modal-header {
  min-height: 62px;
  padding: 16px 20px !important;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0) !important;
  background: var(--surface-card, #fff) !important;
}

.clubsModal .modal-title {
  color: var(--text-strong, #0f172a) !important;
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 18px !important;
  font-weight: 800 !important;
  line-height: 1.3 !important;
}

.clubsModal .modal-header .close,
.clubsModal .modal-header > button[aria-label='Close'] {
  display: inline-flex;
  width: 34px !important;
  height: 34px !important;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  border-radius: 8px !important;
  background: transparent !important;
  color: var(--text-muted, #64748b) !important;
  line-height: 1 !important;
  opacity: 1;
}

.clubsModal .modal-header .close:hover,
.clubsModal .modal-header .close:focus-visible,
.clubsModal .modal-header > button[aria-label='Close']:hover,
.clubsModal .modal-header > button[aria-label='Close']:focus-visible {
  background: var(--surface-sunken, #f1f5f9) !important;
  color: var(--text-strong, #0f172a) !important;
  outline: none;
}

.clubsModal:not(.clubsReportParametersModal):not(.clubsReportsModal) .modal-body {
  min-height: 0;
  padding: 18px 20px !important;
  overflow-y: auto;
  color: var(--text-body, #334155) !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
}

.clubsModal .modal-footer {
  gap: 8px !important;
  padding: 14px 20px !important;
  border-top: 1px solid var(--border-subtle, #e2e8f0) !important;
  background: var(--slate-25, #fafbfc) !important;
}

.clubsModal .modal-footer .btn {
  min-height: 38px;
  margin: 0 !important;
  padding: 0 14px !important;
  border-radius: 8px !important;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 12.5px;
  font-weight: 750;
  box-shadow: none !important;
}

.clubsModal .modal-footer .btn-secondary {
  border-color: var(--border-default, #cbd5e1) !important;
  background: var(--surface-card, #fff) !important;
  color: var(--text-body, #334155) !important;
}

.clubsModal .modal-footer .btn-secondary:hover:not(:disabled) {
  border-color: var(--border-brand, #6fb1df) !important;
  background: var(--blue-50, #eef6fc) !important;
  color: var(--blue-700, #155d8c) !important;
}

.clubsModal .modal-footer .btn-primary {
  border-color: var(--action-primary, #227ebd) !important;
  background: var(--action-primary, #227ebd) !important;
  color: #fff !important;
}

.clubsModal .modal-footer .btn-primary:hover:not(:disabled) {
  border-color: var(--blue-700, #155d8c) !important;
  background: var(--blue-700, #155d8c) !important;
}

.clubsDeleteModal .modal-footer .btn-primary,
.clubsDeleteModal .modal-footer .btn-primary:hover:not(:disabled) {
  border-color: #be123c !important;
  background: #be123c !important;
}

.clubsModalBody {
  padding-bottom: 0 !important;
}

.clubsModalContent {
  display: grid;
  gap: 16px;
}

.clubsModalLead {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--slate-25, #fafbfc);
}

.clubsModalLead.isWarning {
  border-color: var(--amber-100, #ffe9c2);
  background: var(--amber-50, #fff6e6);
}

.clubsModalLead.isDanger {
  border-color: #fecdd3;
  background: #fff1f2;
}

.clubsModalLead.isInfo {
  border-color: #bfdbfe;
  background: var(--blue-50, #eef6fc);
}

.clubsModalLead.isSuccess {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.clubsModalLeadIcon {
  display: inline-flex;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
}

.clubsModalLead.isWarning .clubsModalLeadIcon {
  background: var(--amber-100, #ffe9c2);
  color: var(--amber-700, #a85c07);
}

.clubsModalLead.isDanger .clubsModalLeadIcon {
  background: #ffe4e6;
  color: #be123c;
}

.clubsModalLead.isInfo .clubsModalLeadIcon {
  background: #dbeafe;
  color: var(--blue-700, #155d8c);
}

.clubsModalLead.isSuccess .clubsModalLeadIcon {
  background: #dcfce7;
  color: #15803d;
}

.clubsModalLeadIcon svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.clubsModalLead > div {
  min-width: 0;
}

.clubsModalLead strong {
  display: block;
  margin-bottom: 3px;
  color: var(--text-strong, #0f172a);
  font-size: 13.5px;
  font-weight: 750;
}

.clubsModalLead p {
  margin: 0;
  color: var(--text-body, #334155);
}

.clubsArchiveList {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
}

.clubsArchiveList > div {
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 12px;
}

.clubsArchiveList > div + div {
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.clubsArchiveList strong {
  overflow: hidden;
  color: var(--text-strong, #0f172a);
  font-size: 12.5px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clubsArchiveList span {
  display: inline-flex;
  min-height: 24px;
  flex: 0 0 auto;
  align-items: center;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 10.5px;
  font-weight: 800;
}

.clubsArchiveList span.isWarning {
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
}

.clubsModalActions {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin: 0 -20px;
  padding: 14px 20px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-25, #fafbfc);
}

.clubsModalActions.isEnd {
  justify-content: flex-end;
}

.clubsDsFilterAnchor .clubsDsFilterActions > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.clubsModalButton {
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 12.5px;
  font-weight: 750;
  line-height: 1;
  cursor: pointer;
}

.clubsModalButton.isSecondary {
  border-color: var(--border-default, #cbd5e1);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
}

.clubsModalButton.isSecondary:hover,
.clubsModalButton.isSecondary:focus-visible {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  outline: none;
}

.clubsModalButton.isPrimary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.clubsModalButton.isPrimary:hover,
.clubsModalButton.isPrimary:focus-visible {
  border-color: var(--blue-700, #155d8c);
  background: var(--blue-700, #155d8c);
  outline: none;
}

@media (max-width: 600px) {
  .clubsModal .modal-content {
    max-height: calc(100vh - 24px) !important;
  }

  .clubsModal .modal-header {
    min-height: 58px;
    padding: 13px 16px !important;
  }

  .clubsModal:not(.clubsReportParametersModal):not(.clubsReportsModal) .modal-body {
    padding: 14px 16px !important;
  }

  .clubsModalBody {
    padding-bottom: 0 !important;
  }

  .clubsModalActions {
    margin-right: -16px;
    margin-left: -16px;
    padding: 12px 16px;
  }

  .clubsModalActions .clubsModalButton {
    flex: 1 1 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Clubs/Clubs/Clubs.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,iCAAiC;EACjC,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;EAC1C,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;EACR,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,WAAW;EACX,8BAA8B;EAC9B,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,+CAA+C;EAC/C,qCAAqC;EACrC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;EACb,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;;;;;;EAME,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,kDAAkD;EAClD,gDAAgD;AAClD;;AAEA;;EAEE,gBAAgB;EAChB,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,oCAAoC;EACpC,mCAAmC;EACnC,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,sDAAsD;EACtD,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sDAAsD;EACtD,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;;;EAIE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,UAAU;EACV,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,OAAO;EACP,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;;IAIE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,yCAAyC;EACzC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,mDAAmD;EACnD,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,OAAO;IACP,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,4BAA4B;AAC9B;;AAEA,qFAAqF;AACrF;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,UAAU;EACV,SAAS;EACT,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,oDAAoD;EACpD,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,sDAAsD;EACtD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0CAA0C;EAC1C,oBAAoB;EACpB,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,sDAAsD;EACtD,oCAAoC;EACpC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,sCAAsC;AACxC;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sDAAsD;EACtD,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;EAChC,iBAAiB;AACnB;AACA;;;EAGE,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,SAAS;AACX;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;EAGE,WAAW;AACb;AACA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,SAAS;AACX;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,sCAAsC;EACtC,YAAY;AACd;AACA;;EAEE,SAAS;AACX;AACA;EACE,WAAW;EACX,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,4CAA4C;EAC5C,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,4BAA4B;EAC5B,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,gCAAgC;EAChC,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;;;;;IAKE,wBAAwB;IACxB,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,mDAAmD;EACnD,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;EACnD,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,0DAA0D;EAC1D,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iEAAiE;EACjE,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,8DAA8D;EAC9D,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,0DAA0D;EAC1D,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iEAAiE;EACjE,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,8DAA8D;EAC9D,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,mEAAmE;AACrE;;AAEA;EACE,yCAAyC;EACzC,oBAAoB;EACpB,8BAA8B;EAC9B,gDAAgD;EAChD,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iEAAiE;EACjE,gDAAgD;AAClD;;AAEA;EACE,6CAA6C;EAC7C,yEAAyE;EACzE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,6BAA6B;EAC7B,kCAAkC;EAClC,4CAA4C;EAC5C,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;;;EAIE,qDAAqD;EACrD,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,8DAA8D;EAC9D,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,6BAA6B;EAC7B,mEAAmE;EACnE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,uDAAuD;EACvD,gDAAgD;EAChD,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,uDAAuD;EACvD,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;AACjD;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,mEAAmE;EACnE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;EAEE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;;EAEE,sCAAsC;EACtC,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".mClubSendInvitationsFormWidth {\n  max-width: 700px;\n}\n\n.eClubStudentsTitle,\n.eClubMessagesTitle {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.bMessages,\n.bParticipants {\n  margin-top: 10px;\n}\n\n.bReportFormTitle {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n/* Activate modal polish */\n.cActivateModal {\n  padding-top: 6px;\n}\n\n.cActivateModal__summary {\n  display: grid;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.cActivateModal__summaryCard {\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  padding: 12px 14px;\n  background: #fff;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.04);\n}\n\n.cActivateModal__clubName {\n  font-weight: 700;\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n\n.cActivateModal__grid {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  row-gap: 6px;\n  column-gap: 10px;\n  font-size: 13px;\n}\n\n.cActivateModal__label {\n  color: rgba(0, 0, 0, 0.55);\n}\n.cActivateModal__value {\n  font-weight: 600;\n}\n\n.cActivateModal__note {\n  border-radius: 10px;\n  padding: 10px 12px;\n  background: rgba(0, 0, 0, 0.04);\n  color: rgba(0, 0, 0, 0.75);\n  font-size: 13px;\n  margin: 8px 0 12px;\n}\n\n.cActivateModal__note.isError {\n  background: rgba(220, 53, 69, 0.08);\n  color: rgba(220, 53, 69, 0.95);\n  font-weight: 600;\n}\n\n/* Occurrences block */\n.cActivateModal__occ {\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 12px;\n  padding: 12px 14px;\n  background: #fff;\n}\n\n.cActivateModal__occHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.cActivateModal__occTitle {\n  font-weight: 800;\n  font-size: 14px;\n}\n.cActivateModal__occHint {\n  color: rgba(0, 0, 0, 0.55);\n  font-size: 12.5px;\n  margin-top: 2px;\n}\n\n.cActivateModal__occSearch {\n  width: 240px;\n}\n\n.cActivateModal__actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 10px 0 10px;\n  padding: 10px 10px;\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.cActivateModal__count {\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 13px;\n}\n\n.cActivateModal__list {\n  max-height: 260px;\n  overflow: auto;\n  padding-right: 6px;\n}\n\n.cActivateModal__row {\n  display: grid;\n  grid-template-columns: 18px 1fr auto;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 10px;\n  border-radius: 10px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  user-select: none;\n}\n\n.cActivateModal__row:hover {\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.cActivateModal__row.isChecked {\n  border-color: rgba(0, 0, 0, 0.1);\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.cActivateModal__date {\n  font-weight: 650;\n  font-size: 13px;\n}\n.cActivateModal__time {\n  color: rgba(0, 0, 0, 0.55);\n  font-size: 13px;\n}\n\n.cActivateModal__muted {\n  color: rgba(0, 0, 0, 0.55);\n  font-size: 13px;\n  padding: 8px 2px;\n}\n\n.cActivateModal__empty {\n  padding: 10px 2px;\n}\n\n.cActivateModal__emptyTitle {\n  font-weight: 750;\n  margin-bottom: 2px;\n}\n\n.cActivateModal__list {\n  min-height: 140px;\n}\n\n.mActivateStats {\n  display: grid;\n  row-gap: 6px;\n}\n\n.mActivateStatsRow {\n  display: grid;\n  grid-template-columns: 170px max-content;\n  column-gap: 12px;\n  align-items: center;\n}\n\n.mActivateStatsLabel {\n  color: #6c757d;\n  font-size: 13px;\n}\n\n.mActivateStatsValue {\n  text-align: left;\n  font-weight: 600;\n  color: #343a40;\n}\n\n.mActivateOccurrences input[type='checkbox'] {\n  accent-color: #adb5bd;\n}\n\n/* New design: club activation */\n.clubsActivateModal .modal-body {\n  padding: 20px 24px !important;\n}\n\n.clubsActivateModal .modal-footer .btn-secondary {\n  border-color: #cfd8e3 !important;\n  background: #fff !important;\n  background-image: none !important;\n  color: #142033 !important;\n}\n\n.clubsActivateModal .modal-footer .btn-primary {\n  border-color: #227ebd !important;\n  background: #227ebd !important;\n  background-image: none !important;\n  color: #fff !important;\n  box-shadow: 0 8px 18px rgba(34, 126, 189, 0.22) !important;\n}\n\n.clubsActivateModal .modal-footer .btn-primary:hover:not(:disabled),\n.clubsActivateModal .modal-footer .btn-primary:focus:not(:disabled) {\n  border-color: #1a6da3 !important;\n  background: #1a6da3 !important;\n  background-image: none !important;\n}\n\n.clubsActivateModal .modal-footer .btn-secondary:hover:not(:disabled),\n.clubsActivateModal .modal-footer .btn-secondary:focus:not(:disabled) {\n  border-color: #9fb0c3 !important;\n  background: #f7f9fc !important;\n  background-image: none !important;\n}\n\n.cActivateModal {\n  display: grid;\n  gap: 16px;\n  padding: 0;\n}\n\n.cActivateModal__intro {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.cActivateModal__introIcon {\n  display: grid;\n  width: 40px;\n  height: 40px;\n  flex: 0 0 40px;\n  place-items: center;\n  border-radius: 10px;\n  background: var(--surface-subtle, #f1f5f9);\n  color: var(--action-primary, #1674d1);\n}\n\n.cActivateModal__introIcon svg,\n.cActivateModal__note svg {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.cActivateModal__intro > div,\n.cActivateModal__sectionHead > div {\n  display: grid;\n  gap: 2px;\n}\n\n.cActivateModal__intro strong,\n.cActivateModal__sectionHead strong,\n.cActivateModal__occTitle {\n  color: var(--text-strong, #142033);\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.cActivateModal__intro span,\n.cActivateModal__sectionHead span,\n.cActivateModal__occHint {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.cActivateModal__sectionHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 2px;\n}\n\n.cActivateModal__sectionCount {\n  display: inline-grid;\n  min-width: 24px;\n  height: 24px;\n  padding: 0 7px;\n  place-items: center;\n  border-radius: 999px;\n  background: var(--surface-subtle, #eef2f7);\n  color: var(--text-body, #334155) !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n}\n\n.cActivateModal__summary {\n  display: block;\n  overflow: hidden;\n  margin: 0;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: #fff;\n}\n\n.cActivateModal__summaryCard {\n  display: grid;\n  grid-template-columns: minmax(180px, 1fr) minmax(310px, auto);\n  align-items: center;\n  gap: 18px;\n  padding: 12px 14px;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.cActivateModal__summaryCard + .cActivateModal__summaryCard {\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.cActivateModal__clubName {\n  overflow: hidden;\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 650;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mActivateStats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(92px, 1fr));\n  gap: 14px;\n}\n\n.mActivateStatsRow {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n}\n\n.mActivateStatsLabel {\n  color: var(--text-muted, #64748b);\n  font-size: 10px;\n  font-weight: 650;\n  letter-spacing: 0.035em;\n  text-transform: uppercase;\n}\n\n.mActivateStatsValue {\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.cActivateModal__note {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  margin: 0;\n  padding: 10px 12px;\n  border: 1px solid var(--info-border, #bfdbfe);\n  border-radius: 9px;\n  background: var(--info-surface, #eff6ff);\n  color: var(--info-text, #1e5f99);\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.cActivateModal__note svg {\n  width: 17px;\n  height: 17px;\n  flex: 0 0 17px;\n  margin-top: 1px;\n}\n\n.cActivateModal__note.isError {\n  border-color: var(--danger-border, #fecdd3);\n  background: var(--danger-surface, #fff1f2);\n  color: var(--danger-text, #be123c);\n  font-weight: 400;\n}\n\n.cActivateModal__occ {\n  margin-top: 20px;\n  padding: 18px 0 0;\n  border: 0;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 0;\n}\n\n.cActivateModal__occHeader {\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.cActivateModal__occSearch {\n  display: grid;\n  width: 82px;\n  gap: 4px;\n  color: var(--text-muted, #64748b);\n  font-size: 10px;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.cActivateModal__occSearch input {\n  width: 100%;\n  height: 36px;\n  padding: 0 10px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  outline: none;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.cActivateModal__occSearch input:focus {\n  border-color: var(--action-primary, #1674d1);\n  box-shadow: 0 0 0 3px rgba(22, 116, 209, 0.12);\n}\n\n.cActivateModal__actions {\n  margin: 10px 0 8px;\n  padding: 0;\n  background: transparent;\n}\n\n.cActivateModal__actionsLeft {\n  display: flex;\n  gap: 12px;\n}\n\n.cActivateModal__actionsLeft button {\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--action-primary, #1674d1);\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.cActivateModal__count {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n\n.cActivateModal__list {\n  min-height: 120px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 9px;\n}\n\n.cActivateModal__row {\n  min-height: 40px;\n  padding: 8px 10px;\n  border: 0;\n  border-bottom: 1px solid var(--border-subtle, #edf1f5);\n  border-radius: 0;\n}\n\n.cActivateModal__row:hover {\n  background: var(--surface-hover, #f8fafc);\n}\n\n.cActivateModal__row.isChecked {\n  border-color: var(--border-subtle, #edf1f5);\n  background: var(--selection-subtle, #f3f8fd);\n}\n\n.mActivateOccurrences input[type='checkbox'] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--action-primary, #1674d1);\n}\n\n.cActivateModal__validation {\n  margin-top: 9px;\n  color: var(--danger-text, #be123c);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n@media (max-width: 680px) {\n  .cActivateModal__summaryCard {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .mActivateStats {\n    gap: 8px;\n  }\n}\n\n/* Design-system clubs list */\n.clubsDsPage {\n  display: block;\n  width: 100%;\n  min-height: calc(100vh - 88px);\n  padding: 0 0 32px;\n  background: var(--surface-page, #f6f8fb);\n  color: var(--text-body, #243244);\n  font-family: var(--font-body, inherit);\n}\n\n.clubsDsPage.hasDrawer {\n  display: block;\n}\n\n.clubsDsMain {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.clubsDsSelectionBar,\n.clubsDsFilters {\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  background: var(--surface-card, #fff);\n  border-radius: 14px;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);\n}\n\n.clubsDsHeader {\n  display: flex;\n  width: calc(100% + 48px);\n  min-height: 70px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin: -20px 0 0 -24px;\n  padding: 0 72px 0 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.clubsDsHeaderTitle {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n}\n\n.clubsDsHeader h1 {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-family: var(--font-display, inherit);\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.clubsDsHeaderTitle > span {\n  display: inline-flex;\n  min-width: 24px;\n  height: 22px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11.5px;\n  font-weight: 800;\n}\n\n.clubsDsContentCard {\n  overflow: visible;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.clubsDsToolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  flex-wrap: wrap;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.clubsDsToolbarTitle {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.clubsDsToolbarTitle strong {\n  color: var(--text-strong, #142033);\n  font-size: 15px;\n  font-weight: 750;\n}\n\n.clubsDsToolbarTitle span,\n.clubsDsFooter span {\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  font-weight: 600;\n}\n\n.clubsDsSearch {\n  position: relative;\n  flex: 0 1 360px;\n  width: min(360px, 100%);\n  color: var(--text-subtle, #8a96a8);\n}\n\n.clubsDsSearch input,\n.clubsDsFilterField select,\n.clubsDsDateRange input {\n  width: 100%;\n  height: 40px;\n  border: 1px solid var(--border-default, #cfd8e3);\n  border-radius: 10px;\n  background: #fff;\n  color: var(--text-strong, #142033);\n  font: inherit;\n  font-size: 13.5px;\n  outline: none;\n}\n\n.clubsDsSearch input {\n  padding: 0 12px;\n}\n\n.clubsDsSearch input:focus,\n.clubsDsFilterField select:focus,\n.clubsDsDateRange input:focus {\n  border-color: var(--blue-500, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.14);\n}\n\n.clubsDsBtn,\n.clubsDsIconTextBtn,\n.clubsDsIconBtn,\n.clubsDsPager button,\n.clubsDsMenuPanel button,\n.clubsDsSort {\n  font: inherit;\n  cursor: pointer;\n}\n\n.clubsDsBtn,\n.clubsDsIconTextBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 38px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: 1px solid transparent;\n  font-size: 13.5px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.clubsDsBtnPrimary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  box-shadow: 0 8px 18px rgba(34, 126, 189, 0.22);\n}\n\n.clubsDsBtnPrimary:hover:not(:disabled) {\n  border-color: var(--action-primary-hover, #1a6da3);\n  background: var(--action-primary-hover, #1a6da3);\n}\n\n.clubsDsBtnSecondary,\n.clubsDsIconTextBtn {\n  background: #fff;\n  color: var(--text-strong, #142033);\n  border-color: var(--border-default, #cfd8e3);\n}\n\n.clubsDsBtnGhost {\n  background: transparent;\n  color: var(--text-muted, #69778a);\n  border-color: transparent;\n}\n\n.clubsDsBtnDanger {\n  background: var(--red-600, #dc2626);\n  color: #fff;\n  border-color: var(--red-600, #dc2626);\n}\n\n.clubsDsSelectionBar {\n  display: flex;\n  min-height: 0;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 0;\n  padding: 8px 14px;\n  flex-wrap: wrap;\n  border-color: var(--blue-100, #d4e8f6);\n  border-radius: var(--radius-md, 8px);\n  background: var(--blue-50, #eef6fc);\n  box-shadow: none;\n  color: var(--blue-700, #155d8c);\n  font-size: 13px;\n}\n\n.clubsDsSelectionCount {\n  margin-right: 4px;\n  color: var(--blue-700, #155d8c);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.clubsDsSelectionBar .clubsDsBtn {\n  height: 32px;\n  min-height: 32px;\n  padding: 0 11px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.clubsDsSelectionBar .clubsDsBtnGhost {\n  height: auto;\n  min-height: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n}\n\n.clubsDsSelectionBar .clubsDsBtnGhost:hover {\n  text-decoration: underline;\n}\n\n.clubsDsMenu {\n  position: relative;\n  display: inline-flex;\n}\n\n.clubsDsMenuPanel {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  z-index: 40;\n  display: none;\n  min-width: 240px;\n  padding: 6px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.16);\n}\n\n.clubsDsMenuPanel.isRight {\n  left: auto;\n  right: 0;\n}\n\n.clubsDsMenu:hover .clubsDsMenuPanel,\n.clubsDsMenu:focus-within .clubsDsMenuPanel {\n  display: block;\n}\n\n.clubsDsMenuPanel button {\n  display: flex;\n  width: 100%;\n  min-height: 34px;\n  align-items: center;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-body, #243244);\n  padding: 8px 10px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.clubsDsMenuPanel button:hover:not(:disabled) {\n  background: var(--blue-50, #eaf5fc);\n  color: var(--blue-700, #164170);\n}\n\n.clubsDsMenuPanel button:disabled {\n  cursor: not-allowed;\n  color: var(--text-subtle, #9aa6b2);\n}\n\n.clubsDsFilters {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(120px, 1fr)) auto;\n  gap: 12px;\n  padding: 14px;\n}\n\n.clubsDsFilterField span {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.clubsDsFilterField select {\n  padding: 0 10px;\n}\n\n.clubsDsDateRange {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.clubsDsDateRange input {\n  padding: 0 10px;\n}\n\n.clubsDsFilterActions {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.clubsDsTableCard {\n  overflow: hidden;\n  border: 0;\n  border-radius: 0;\n  background: #fff;\n  box-shadow: none;\n}\n\n.clubsDsTableScroll {\n  overflow: auto;\n}\n\n.clubsDsTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  min-width: 1120px;\n}\n\n.clubsDsTable th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  height: 44px;\n  background: var(--slate-25, #f8fafc);\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n  color: var(--text-muted, #69778a);\n  padding: 0 12px;\n  text-align: left;\n  font-size: 11.5px;\n  font-weight: 800;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.clubsDsTable td {\n  height: 56px;\n  border-bottom: 1px solid var(--border-subtle, #edf1f5);\n  color: var(--text-body, #243244);\n  padding: 8px 12px;\n  font-size: 13px;\n  vertical-align: middle;\n}\n\n.clubsDsTable tbody tr {\n  cursor: pointer;\n}\n\n.clubsDsTable tbody tr:hover,\n.clubsDsTable tbody tr.isPreview {\n  background: var(--blue-50, #eaf5fc);\n}\n\n.clubsDsBtnSecondary:hover:not(:disabled),\n.clubsDsBtnSecondary:focus-visible,\n.clubsDsIconTextBtn:hover,\n.clubsDsIconTextBtn:focus-visible {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  outline: none;\n}\n\n.clubsDsOpenCell {\n  width: 40px;\n  min-width: 40px;\n  padding-right: 10px !important;\n  padding-left: 10px !important;\n  text-align: center !important;\n}\n\n.clubsDsOpenCell > span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 22px;\n  line-height: 1;\n  opacity: 0;\n  transform: translateX(-3px);\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.clubsDsTable tbody tr:hover .clubsDsOpenCell > span,\n.clubsDsTable tbody tr.isPreview .clubsDsOpenCell > span {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.clubsDsCheckCell {\n  width: 44px;\n  text-align: center !important;\n}\n\n.clubsDsCheckCell input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--blue-600, #227ebd);\n}\n\n.clubsDsSort {\n  border: 0;\n  background: transparent;\n  color: inherit;\n  padding: 0;\n  font-size: inherit;\n  font-weight: inherit;\n  text-transform: inherit;\n}\n\n.clubsDsClubCell {\n  display: flex;\n  align-items: center;\n  min-width: 180px;\n}\n\n.clubsDsToolbarTitle .clubsDsToolbarCount {\n  display: inline-flex;\n  min-width: 28px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 9px;\n  border-radius: var(--radius-pill, 999px);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.clubsDsClubIcon,\n.clubsDsDrawerIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  background: var(--blue-50, #eaf5fc);\n  color: var(--blue-700, #164170);\n}\n\n.clubsDsClubIcon {\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n}\n\n.clubsDsClubCell strong,\n.clubsDsClubCell small {\n  display: block;\n}\n\n.clubsDsClubCell strong {\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 750;\n}\n\n.clubsDsClubCell small {\n  margin-top: 2px;\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n}\n\n.clubsDsChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.clubsDsChips span {\n  display: inline-flex;\n  align-items: center;\n  min-height: 22px;\n  padding: 0 8px;\n  border-radius: 6px;\n  background: var(--slate-100, #edf2f7);\n  color: var(--text-body, #243244);\n  font-size: 11.5px;\n  font-weight: 700;\n}\n\n.clubsDsBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 24px;\n  padding: 0 9px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.clubsDsBadge::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.clubsDsBadge.isSuccess {\n  background: #eaf7ed;\n  color: #217a3a;\n}\n.clubsDsBadge.isWarning {\n  background: #fff4d8;\n  color: #9a6500;\n}\n.clubsDsBadge.isNeutral {\n  background: #edf2f7;\n  color: #536173;\n}\n\n.clubsDsEmpty {\n  height: 120px !important;\n  text-align: center;\n  color: var(--text-muted, #69778a) !important;\n}\n\n.clubsDsFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n}\n\n.clubsDsPager {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.clubsDsPager button {\n  height: 34px;\n  border: 1px solid var(--border-default, #cfd8e3);\n  border-radius: 9px;\n  background: #fff;\n  color: var(--text-strong, #142033);\n  padding: 0 12px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.clubsDsPager button:disabled {\n  cursor: not-allowed;\n  color: var(--text-subtle, #9aa6b2);\n}\n\n.clubsDsDrawerScrim {\n  position: fixed;\n  inset: 0;\n  z-index: 2147483000;\n  background: rgba(15, 23, 42, 0.34);\n}\n\n.clubsDsDrawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2147483001;\n  width: 560px;\n  max-width: 94vw;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: -12px 0 42px rgba(15, 23, 42, 0.18);\n}\n\n.clubsDsDrawerHeader {\n  display: grid;\n  grid-template-columns: 46px minmax(0, 1fr) 34px;\n  gap: 12px;\n  align-items: start;\n  padding: 18px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.clubsDsDrawerIcon {\n  width: 46px;\n  height: 46px;\n  border-radius: 12px;\n}\n\n.clubsDsDrawerHeader h2 {\n  margin: 0 0 8px;\n  color: var(--text-strong, #142033);\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.clubsDsDrawerMeta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  font-weight: 600;\n}\n\n.clubsDsDrawerMeta > span:not(:first-child):not(.clubsDsBadge)::before {\n  margin-right: 8px;\n  color: var(--text-subtle, #9aa6b2);\n  content: '·';\n}\n\n.clubsDsIconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 9px;\n  background: #fff;\n  color: var(--text-muted, #69778a);\n}\n\n.clubsDsDrawerTabs {\n  display: flex;\n  overflow-x: auto;\n  gap: 4px;\n  padding: 0 14px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.clubsDsDrawerTabs button {\n  height: 42px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--text-muted, #69778a);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 750;\n  white-space: nowrap;\n}\n\n.clubsDsDrawerTabs button.isActive {\n  color: var(--blue-700, #164170);\n  border-bottom-color: var(--blue-600, #227ebd);\n}\n\n.clubsDsDrawerBody {\n  flex: 1;\n  overflow: auto;\n  padding: 16px 18px;\n  scrollbar-gutter: stable;\n}\n\n.clubsDsDetailsGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 28px;\n  gap: 0;\n}\n\n.clubsDsDetailsGrid > div {\n  display: grid;\n  gap: 3px;\n  padding: 11px 0;\n  border-bottom: 1px solid var(--border-subtle, #edf1f5);\n}\n\n.clubsDsDetailsGrid span {\n  color: var(--text-muted, #69778a);\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.clubsDsDetailsGrid strong {\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 650;\n}\n\n.clubsDsDetailsGrid strong em {\n  color: var(--text-muted, #69778a);\n  font-style: normal;\n  font-weight: 500;\n}\n\n.clubDetailList {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0 28px;\n  margin: 0;\n}\n\n.clubDetailList__item {\n  display: grid;\n  grid-template-columns: minmax(120px, 0.8fr) minmax(0, 1.2fr);\n  gap: 14px;\n  align-items: baseline;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border-subtle, #edf1f5);\n}\n\n.clubDetailList__item dt {\n  margin: 0;\n  color: var(--text-muted, #69778a);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.clubDetailList__item dd {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 650;\n  white-space: pre-line;\n}\n\n.clubDetailList__item dd.isEmpty {\n  color: var(--text-muted, #69778a);\n  font-weight: 500;\n}\n\n.clubsDsDrawerEmpty {\n  display: grid;\n  min-height: 260px;\n  align-content: center;\n  justify-items: center;\n  gap: 6px;\n  padding: 28px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  color: var(--text-muted, #69778a);\n  text-align: center;\n}\n\n.clubsDsDrawerEmpty__icon {\n  display: inline-flex;\n  width: 42px;\n  height: 42px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n  border-radius: 12px;\n  background: var(--blue-50, #eef8ff);\n  color: var(--blue-700, #17659a);\n}\n\n.clubsDsDrawerEmpty .clubsDsBtn {\n  margin-top: 10px;\n}\n\n.clubsDsDrawerEmpty strong {\n  color: var(--text-strong, #142033);\n  font-size: 15px;\n}\n\n.clubsDsParticipantsList {\n  display: flex;\n  flex-direction: column;\n}\n.clubsDsParticipantActions {\n  display: flex;\n  justify-content: flex-end;\n  padding-bottom: 12px;\n  margin-bottom: 4px;\n  border-bottom: 1px solid var(--border-subtle, #edf1f5);\n}\n.clubsDsParticipant {\n  display: grid;\n  min-height: 58px;\n  grid-template-columns: 28px 36px minmax(0, 1fr);\n  align-items: center;\n  gap: 11px;\n  padding: 9px 2px;\n  border-bottom: 1px solid var(--border-subtle, #edf1f5);\n}\n.clubsDsParticipantAvatar {\n  display: inline-flex;\n  width: 36px;\n  height: 36px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--blue-50, #eef8ff);\n  color: var(--blue-700, #17659a);\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n.clubsDsParticipantCopy {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n.clubsDsParticipantCopy strong {\n  overflow: hidden;\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.clubsDsParticipantCopy small {\n  color: var(--text-muted, #69778a);\n  font-size: 11.5px;\n}\n.clubsDsParticipantNumber {\n  display: inline-flex;\n  min-width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 10.5px;\n  font-weight: 750;\n}\n\n.clubsDsEventsTab {\n  display: grid;\n  gap: 14px;\n}\n\n.clubsDsEventStats {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.clubsDsEventStats > div {\n  display: grid;\n  min-width: 0;\n  gap: 5px;\n  padding: 12px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  background: var(--surface-subtle, #f8fafc);\n}\n\n.clubsDsEventStats span {\n  overflow: hidden;\n  color: var(--text-muted, #69778a);\n  font-size: 10.5px;\n  font-weight: 750;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.clubsDsEventStats strong {\n  color: var(--text-strong, #142033);\n  font-size: 21px;\n  font-weight: 850;\n}\n\n.clubsDsEventStats .isUpcoming {\n  border-color: var(--blue-200, #bfdbfe);\n  background: var(--blue-50, #eff6ff);\n}\n\n.clubsDsEventStats .isUpcoming strong {\n  color: var(--blue-700, #155d8c);\n}\n\n.clubsDsEventStats .isPast strong {\n  color: var(--text-muted, #64748b);\n}\n\n.clubsDsEventStats .isCancelled strong {\n  color: var(--red-700, #b42318);\n}\n\n.clubsDsEventInsight {\n  display: grid;\n  gap: 4px;\n  padding: 14px 16px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 11px;\n  background: var(--surface-card, #fff);\n}\n\n.clubsDsEventInsight strong {\n  color: var(--text-strong, #142033);\n  font-size: 13.5px;\n  font-weight: 800;\n}\n\n.clubsDsEventInsight span {\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n\n.clubsDsInvitationsTab {\n  display: grid;\n  gap: 16px;\n}\n\n.clubsDsInvitationIntro,\n.clubsDsInvitationBookings {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: #fff;\n}\n\n.clubsDsInvitationIntro > div,\n.clubsDsInvitationBookings > div,\n.clubsDsInvitationNotice {\n  display: grid;\n  gap: 5px;\n}\n\n.clubsDsInvitationIntro strong,\n.clubsDsInvitationBookings strong,\n.clubsDsInvitationNotice strong {\n  color: var(--text-strong, #142033);\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.clubsDsInvitationIntro span,\n.clubsDsInvitationBookings span,\n.clubsDsInvitationNotice span {\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n\n.clubsDsInvitationStats {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.clubsDsInvitationStats > div {\n  display: grid;\n  gap: 6px;\n  min-width: 0;\n  padding: 13px 12px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  background: var(--surface-subtle, #f8fafc);\n}\n\n.clubsDsInvitationStats span {\n  color: var(--text-muted, #69778a);\n  font-size: 10.5px;\n  font-weight: 750;\n  line-height: 1.25;\n}\n\n.clubsDsInvitationStats strong {\n  color: var(--text-strong, #142033);\n  font-size: 22px;\n  font-weight: 850;\n}\n\n.clubsDsInvitationStats .isAccepted strong {\n  color: var(--green-700, #15803d);\n}\n\n.clubsDsInvitationStats .isRejected strong {\n  color: var(--red-700, #b42318);\n}\n\n.clubsDsInvitationNotice {\n  padding: 14px 16px;\n  border: 1px solid var(--blue-200, #bfdbfe);\n  border-radius: 12px;\n  background: var(--blue-50, #eff6ff);\n}\n\n@media (max-width: 860px) {\n  .clubsDsEventStats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .clubsDsInvitationStats {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .clubsDsInvitationIntro,\n  .clubsDsInvitationBookings {\n    align-items: stretch;\n    flex-direction: column;\n  }\n}\n\n.clubBookingResponseDrawer {\n  width: min(760px, calc(100vw - 24px));\n}\n\n.clubBookingResponseMeta {\n  margin-bottom: 22px;\n}\n\n.clubBookingResponseAnswers {\n  padding: 18px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: #fff;\n}\n\n.clubBookingResponseAnswers h3 {\n  margin: 0 0 16px;\n  color: var(--text-strong, #142033);\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.clubsDsBadge.isInfo {\n  border-color: var(--blue-200, #bfdbfe);\n  background: var(--blue-50, #eff6ff);\n  color: var(--blue-700, #155d8c);\n}\n\n.clubsDsBadge.isWarning {\n  border-color: #fedf89;\n  background: #fffaeb;\n  color: #b54708;\n}\n\n.clubsDsDrawerFooter {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  padding: 14px 16px;\n  border-top: 1px solid var(--border-subtle, #dbe3ec);\n  background: var(--slate-25, #f8fafc);\n}\n\n@media (max-width: 1180px) {\n  .clubsDsPage.hasDrawer {\n    grid-template-columns: 1fr;\n  }\n\n  .clubsDsFilters {\n    grid-template-columns: repeat(2, minmax(140px, 1fr));\n  }\n}\n\n@media (max-width: 1217px) {\n  .clubsDsHeader {\n    width: 100vw;\n    margin-left: -12px;\n    padding-right: 28px;\n  }\n}\n\n@media (max-width: 720px) {\n  .clubsDsDetailsGrid,\n  .clubDetailList {\n    grid-template-columns: 1fr;\n  }\n\n  .clubsDsPage {\n    padding: 0 0 20px;\n  }\n\n  .clubsDsHeader,\n  .clubsDsToolbar,\n  .clubsDsSelectionBar,\n  .clubsDsFooter {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .clubsDsHeader {\n    min-height: 64px;\n    align-items: center;\n    flex-direction: row;\n    padding: 0 16px;\n  }\n\n  .clubsDsContentCard {\n    margin: 0 12px;\n  }\n\n  .clubsDsFooter {\n    align-items: center;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n  }\n\n  .clubsDsSearch {\n    width: 100%;\n  }\n\n  .clubsDsFilters {\n    grid-template-columns: 1fr;\n  }\n}\n\n.clubsDsIconTextBtn.isActive {\n  border-color: var(--action-primary, #227ebd);\n  color: var(--blue-700, #155d8c);\n  background: var(--blue-50, #eef7fd);\n}\n\n.clubsDsColumns {\n  position: relative;\n  display: inline-flex;\n}\n\n.clubsDsBtnBadge {\n  min-width: 20px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: var(--surface-muted, #edf2f7);\n  color: var(--text-muted, #536173);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.clubsDsColumnsMenu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 35;\n  width: 252px;\n  padding: 8px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.16);\n}\n\n.clubsDsColumnsHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 7px 8px 9px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.clubsDsColumnsHead button {\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.clubsDsColumnsItem {\n  min-height: 34px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 8px;\n  border-radius: 6px;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.clubsDsColumnsItem:hover {\n  background: var(--surface-hover, #f8fafc);\n}\n\n.clubsDsColumnsItem input {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: var(--action-primary, #227ebd);\n}\n\n.clubsDsColumnsItem.isLocked {\n  color: var(--text-subtle, #94a3b8);\n  cursor: default;\n}\n\n.clubsDsFilterFieldWide {\n  grid-column: span 2;\n}\n\n.clubsDsFilterChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  min-height: 40px;\n  padding: 3px;\n}\n\n.clubsDsFilterChip {\n  min-height: 32px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  padding: 0 11px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.clubsDsFilterChip:hover {\n  border-color: var(--border-brand, #6fb1df);\n  color: var(--blue-700, #155d8c);\n}\n\n.clubsDsFilterChip.isSelected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.clubsDsFooter {\n  justify-content: flex-end;\n  margin-top: 0;\n  padding: 12px 16px;\n  border: 0;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 0 0 11px 11px;\n  background: var(--surface-card, #fff);\n  box-shadow: none;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n\n.clubsDsPaginationSummary {\n  margin-right: 4px;\n}\n\n.clubsDsPaginationEllipsis {\n  min-width: 18px;\n  text-align: center;\n  color: var(--text-subtle, #94a3b8);\n}\n\n.clubsDsPageBtn,\n.clubsDsPagerBtn {\n  min-width: 34px;\n  height: 34px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  padding: 0 12px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.clubsDsPageBtn:hover,\n.clubsDsPagerBtn:hover:not(:disabled) {\n  border-color: var(--border-brand, #6fb1df);\n  color: var(--blue-700, #155d8c);\n}\n\n.clubsDsPageBtn.isActive {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.clubsDsPagerBtn:disabled {\n  cursor: default;\n  color: var(--text-subtle, #94a3b8);\n}\n\n@media (max-width: 720px) {\n  .clubsDsFilterFieldWide {\n    grid-column: auto;\n  }\n\n  .clubsDsColumnsMenu {\n    left: 0;\n    right: auto;\n    width: min(252px, 90vw);\n  }\n}\n\n.clubsDsDateRange .sit-dp,\n.clubsDsDateRange .sit-dp__pop {\n  z-index: 10000;\n}\n\n.clubsDsDateRange .sit-dp__pop {\n  position: fixed;\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  transform: translate(-50%, -50%);\n  overflow: hidden;\n  overscroll-behavior: contain;\n  align-items: stretch;\n  animation: none;\n}\n\n.clubsDsDateRange .sit-dp__pop > div:last-child {\n  min-width: 0;\n  min-height: 0;\n  max-height: calc(100vh - 32px);\n  display: flex;\n  flex-direction: column;\n}\n\n.clubsDsDateRange .sit-dp__pop > div:last-child > div:first-child {\n  min-height: 0;\n  overflow: auto;\n  overscroll-behavior: contain;\n}\n\n/* List filters handoff: right-side drawer for the large, control-heavy filter set. */\n.clubsDsFilterAnchor {\n  position: static;\n  flex: 0 0 auto;\n}\n\n.clubsRoute {\n  margin-top: 0 !important;\n}\n\n.clubsDsFilterScrim {\n  position: fixed;\n  z-index: 1055;\n  inset: 0;\n  width: 100vw;\n  height: 100vh;\n  padding: 0;\n  border: 0;\n  background: rgba(15, 23, 42, 0.28);\n  cursor: default;\n}\n\n.clubsDsFilterAnchor .clubsDsFilters {\n  position: fixed;\n  z-index: 1060;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  display: flex;\n  width: 360px;\n  max-width: calc(100vw - 20px);\n  height: auto;\n  max-height: none;\n  flex-direction: column;\n  gap: 0;\n  padding: 0;\n  overflow: hidden;\n  border: 0;\n  border-left: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 0;\n  background: #fff;\n  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.clubsDsFilterHead {\n  display: flex;\n  min-height: 34px;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0;\n  padding: 15px 18px;\n  border-bottom: 1px solid var(--border-subtle, #e7edf3);\n}\n\n.clubsDsFilterHead strong {\n  color: var(--text-strong, #172b4d);\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.clubsDsFilterHead .clubsDsFilterClose {\n  display: inline-flex;\n  width: 30px;\n  height: 30px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-muted, #667085);\n  font-size: 22px;\n  line-height: 1;\n  font-weight: 400;\n  cursor: pointer;\n}\n\n.clubsDsFilterHead .clubsDsFilterClose:hover {\n  background: var(--surface-hover, #f2f4f7);\n  color: var(--text-strong, #172b4d);\n}\n\n.clubsDsFilterBody {\n  display: grid;\n  flex: 1 1 auto;\n  min-height: 0;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  padding: 16px 18px 22px;\n  overflow-y: auto;\n}\n\n.clubsDsFilterBody .clubsDsFilterFieldWide {\n  grid-column: auto;\n}\n\n.clubsDsFilterBody .clubsDsFilterField > span {\n  margin-bottom: 7px;\n  color: #475467;\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.clubsDsFilterBody .clubsDsFilterField select,\n.clubsDsFilterBody .sit-dp__trigger {\n  width: 100%;\n  height: 38px;\n  min-height: 38px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background-color: #fff;\n  font-size: 13px;\n}\n\n.clubsDsFilterBody .clubsDsDateRange {\n  display: block;\n  width: 100%;\n}\n\n.clubsDsFilterBody .clubsDsFilterChips {\n  gap: 7px;\n  min-height: 0;\n  padding: 0;\n}\n\n.clubsDsFilterBody .clubsDsFilterChip {\n  min-height: 32px;\n  border-radius: 999px;\n  padding: 0 11px;\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.clubsDsFilterAnchor .clubsDsFilterActions {\n  min-height: 64px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 14px 18px;\n  border-top: 1px solid var(--border-subtle, #e7edf3);\n  background: #fff;\n}\n\n.clubsDsFilterAnchor .clubsDsFilterActions .clubsDsBtn {\n  height: 38px;\n  min-height: 38px;\n}\n\n.clubsDsActiveFilters {\n  display: flex;\n  min-height: 44px;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding: 8px 16px;\n  border: 0;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 0;\n  background: #fff;\n}\n\n.clubsDsActiveFilters button {\n  display: inline-flex;\n  min-height: 30px;\n  align-items: center;\n  gap: 6px;\n  padding: 0 10px;\n  border: 1px solid var(--blue-200, #b9dff2);\n  border-radius: 999px;\n  background: var(--blue-50, #eef8fc);\n  color: var(--blue-800, #124f76);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.clubsDsActiveFilters button:hover {\n  border-color: var(--blue-400, #5aaed6);\n  background: #e3f3fb;\n}\n\n.modal-dialog.modal-xl.clubsReportsModal {\n  width: min(540px, calc(100vw - 32px)) !important;\n  min-width: 0 !important;\n  max-width: 540px !important;\n  overflow: visible !important;\n}\n.clubsReportsModal .modal-content {\n  display: flex;\n  height: auto;\n  max-height: calc(100vh - 48px);\n  flex-direction: column;\n  overflow: hidden !important;\n  border: 0;\n  border-radius: 16px;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);\n}\n.clubsReportsModal .modal-header {\n  flex: 0 0 auto;\n}\n.clubsReportsModal .modal-body {\n  display: flex;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  padding: 0 !important;\n  overflow: hidden !important;\n}\n.clubsReportsModal__intro {\n  flex: 0 0 auto;\n  padding: 11px 18px;\n  border-bottom: 1px solid var(--border-subtle, #e5eaf0);\n  background: var(--slate-25, #f8fafc);\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  line-height: 1.4;\n}\n.clubsReportsModal__group {\n  min-height: 0;\n  max-height: min(520px, calc(100vh - 168px));\n  flex: 0 1 auto;\n  padding: 13px 18px 16px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n}\n.clubsReportsModal__group h3 {\n  margin: 0 0 10px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.055em;\n  text-transform: uppercase;\n}\n.clubsReportsModal__list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.clubsReportsModal__list > button {\n  display: grid;\n  min-height: 58px;\n  grid-template-columns: 32px minmax(0, 1fr) 16px;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 11px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 9px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  text-align: left;\n  cursor: pointer;\n}\n.clubsReportsModal__list > button:hover {\n  border-color: var(--blue-300, #9bc9e7);\n  background: #f8fcff;\n}\n.clubsReportsModal__icon {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: var(--blue-50, #eaf4fb);\n  color: var(--blue-600, #227ebd);\n}\n.clubsReportsModal__icon svg {\n  width: 17px;\n  height: 17px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n.clubsReportsModal__copy,\n.clubsReportsModal__heading {\n  display: flex;\n  min-width: 0;\n}\n.clubsReportsModal__copy {\n  flex-direction: column;\n  gap: 2px;\n}\n.clubsReportsModal__heading {\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n.clubsReportsModal__heading strong {\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 750;\n}\n.clubsReportsModal__format {\n  padding: 3px 7px;\n  border-radius: 999px;\n  background: var(--slate-100, #edf2f7);\n  color: var(--text-muted, #64748b);\n  font-size: 10.5px;\n  font-weight: 750;\n}\n.clubsReportsModal__copy small {\n  color: var(--text-muted, #69778a);\n  font-size: 11px;\n  line-height: 1.3;\n}\n.clubsReportsModal__arrow {\n  color: #94a3b8;\n  font-size: 24px;\n  line-height: 1;\n}\n\n.clubsReportParametersModal.modal-dialog {\n  width: min(680px, calc(100vw - 32px));\n  max-width: 680px;\n  height: min(760px, calc(100vh - 48px));\n}\n.clubsReportParametersModal .modal-content {\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n  border: 0;\n  border-radius: 16px;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);\n}\n.clubsReportParametersModal:has(.clubAttendanceReportForm) {\n  height: min(720px, calc(100vh - 48px));\n}\n.clubsReportParametersModal:has(.clubAttendanceReportForm) .modal-content {\n  height: 100%;\n}\n.clubsReportParametersModal:has(.compactClubReportForm) {\n  height: min(640px, calc(100vh - 48px));\n}\n.clubsReportParametersModal:has(.compactClubReportForm) .modal-content {\n  height: 100%;\n}\n.clubsReportParametersModal__body > form.compactClubReportForm {\n  height: 100%;\n  min-height: 0;\n  flex: 1 1 0;\n  overflow: hidden;\n}\n.clubsReportParametersModal__body > form.clubAttendanceReportForm {\n  height: 100%;\n  min-height: 0;\n  flex: 1 1 0;\n  overflow: hidden;\n}\n.clubAttendanceReportForm .eReportDescription {\n  margin-bottom: 14px;\n}\n.clubAttendanceReportForm .eReportSection {\n  margin-top: 0;\n  padding-top: 0;\n}\n.clubAttendanceReportForm .eReportSection + .eReportSection {\n  margin-top: 16px;\n}\n.clubAttendanceReportForm .eReportActions {\n  position: sticky;\n  z-index: 3;\n  bottom: 0;\n  margin-top: 0;\n}\n.clubsReportParametersModal .modal-header {\n  min-height: 76px;\n  flex: 0 0 auto;\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--border-subtle, #e3e8ef);\n  background: #fff;\n}\n.clubsReportModalTitle {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 12px;\n}\n.clubsReportModalTitle__icon {\n  display: inline-flex;\n  width: 44px;\n  height: 44px;\n  flex: 0 0 44px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: var(--blue-50, #eef8ff);\n  color: var(--blue-700, #17659a);\n}\n.clubsReportModalTitle__icon svg {\n  width: 22px;\n  height: 22px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.9;\n}\n.clubsReportModalTitle--compact {\n  gap: 9px;\n}\n.clubsReportModalTitle--compact .clubsReportModalTitle__icon {\n  width: 20px;\n  height: 20px;\n  flex-basis: 20px;\n  border-radius: 0;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n}\n.clubsReportModalTitle--compact .clubsReportModalTitle__icon svg {\n  width: 17px;\n  height: 17px;\n}\n.clubsReportModalTitle > span:last-child {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n}\n.clubsReportModalTitle strong {\n  color: var(--text-strong, #142033);\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.25;\n}\n.clubsReportModalTitle small {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n}\n.clubsReportParametersModal .modal-body,\n.clubsReportParametersModal__body {\n  display: flex;\n  min-height: 0;\n  flex-direction: column;\n  padding: 0 !important;\n  overflow: hidden !important;\n}\n.clubsReportParametersModal__body > form {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  padding: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n}\n.clubsReportParametersModal__body > form.eReportForm {\n  display: flex !important;\n  min-height: 0;\n  flex: 1 1 0;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-content: normal;\n  overflow: hidden;\n}\n.clubsReportParametersModal__body > form.eReportForm > .eReportForm__scroll {\n  min-height: 0;\n  flex: 1 1 0;\n  padding-right: 8px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-gutter: stable;\n}\n.clubsReportParametersModal__body > form.eReportForm > .eReportActions {\n  flex: 0 0 auto;\n  margin-top: 0;\n}\n.clubsReportParametersModal__body .bReportFormTitle {\n  display: none;\n}\n.clubsReportParametersModal__body > form > .mb-3.mt-3,\n.clubsReportParametersModal__body .bReportFormTitle + .mb-3 {\n  width: calc(100% - 48px);\n  margin: 18px 24px 8px !important;\n  padding: 14px 16px;\n  border: 1px solid var(--border-subtle, #e3e8ef);\n  border-radius: 11px;\n  background: var(--slate-25, #f8fafc);\n  color: var(--text-body, #334155);\n  line-height: 1.55;\n}\n.clubsReportParametersModal__body .form-group,\n.clubsReportParametersModal__body > form > .form-check,\n.clubsReportParametersModal__body > form > .mt-3.mb-3 {\n  box-sizing: border-box;\n  width: calc(100% - 48px);\n  margin: 7px 24px !important;\n  padding: 12px 14px;\n  border: 1px solid var(--border-subtle, #e3e8ef);\n  border-radius: 11px;\n  background: #fff;\n}\n.clubsReportParametersModal__body .form-group > label:first-child,\n.clubsReportParametersModal__body .form-check-label {\n  margin-bottom: 7px;\n  color: var(--text-strong, #142033);\n  font-size: 12.5px;\n  font-weight: 700;\n}\n.clubsReportParametersModal__body .form-group > .d-flex,\n.clubsReportParametersModal__body .form-check > .d-flex {\n  align-items: center;\n}\n.clubsReportParametersModal__body .sit-switch {\n  flex: 0 0 auto;\n  margin: 0;\n}\n.clubsReportParametersModal__body .form-control {\n  width: 100%;\n  min-height: 40px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 9px;\n  background: #fff;\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  box-shadow: none;\n}\n.clubsReportParametersModal__body .form-control:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n.clubsReportParametersModal__body .react-datepicker-wrapper,\n.clubsReportParametersModal__body .react-datepicker__input-container {\n  width: 100%;\n}\n.clubsReportParametersModal__body .react-datepicker-popper,\n.clubsReportParametersModal__body .sit-dp__pop {\n  z-index: 1200;\n}\n.clubsReportParametersModal__body input[type='radio'],\n.clubsReportParametersModal__body input[type='checkbox'] {\n  accent-color: var(--blue-600, #227ebd);\n}\n.clubsReportParametersModal__body .eMultiSelectCheckboxes > div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n  columns: auto !important;\n}\n.clubsReportParametersModal__body .eMultiSelectCheckbox {\n  position: relative;\n  display: inline-flex;\n  margin: 0;\n  padding: 0;\n  break-inside: avoid;\n}\n.clubsReportParametersModal__body .eMultiSelectCheckbox input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  opacity: 0;\n}\n.clubsReportParametersModal__body .eMultiSelectCheckbox label {\n  display: inline-flex;\n  min-height: 32px;\n  align-items: center;\n  margin: 0;\n  padding: 5px 10px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: #fff;\n  color: var(--text-body, #475569);\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n.clubsReportParametersModal__body .eMultiSelectCheckbox input:checked + label {\n  border-color: var(--blue-600, #227ebd);\n  background: var(--blue-600, #227ebd);\n  color: #fff;\n}\n.clubsReportParametersModal__body .form-group:has(+ .form-group .clubReportDateRange) {\n  display: none;\n}\n.clubsReportParametersModal__body .form-group:has(.clubReportDateRange) > label {\n  display: none;\n}\n.clubsReportParametersModal__body .form-group:has(.clubReportDateRange)::before {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--text-strong, #142033);\n  content: 'Reporting period';\n  font-size: 12.5px;\n  font-weight: 700;\n}\n.clubsReportParametersModal__body .clubReportDateRange,\n.clubsReportParametersModal__body .clubReportSingleDate,\n.clubsReportParametersModal__body .sit-dp {\n  width: 100%;\n}\n.clubsReportParametersModal__body .clubReportDateRange .sit-dp__pop {\n  position: fixed;\n  z-index: 1300;\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  width: max-content;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  transform: translate(-50%, -50%);\n  overflow: auto;\n}\n.clubsReportParametersModal__body .form-group > .d-flex {\n  min-height: 44px;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  gap: 16px;\n}\n.clubsReportParametersModal__body .form-group > .d-flex > .d-flex,\n.clubsReportParametersModal__body .form-check > .d-flex > .d-flex {\n  min-width: 0;\n  flex: 1 1 auto;\n  flex-wrap: wrap;\n  align-items: baseline;\n  justify-content: flex-start !important;\n  gap: 4px 8px;\n}\n.clubsReportParametersModal__body .form-group > .d-flex > .d-flex > label,\n.clubsReportParametersModal__body .form-check > .d-flex > .d-flex > label {\n  margin: 0;\n}\n.clubsReportParametersModal__body .eFieldInlineHint {\n  width: 100%;\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n  font-weight: 400;\n  line-height: 1.35;\n}\n.clubsReportParametersModal__body .form-group > .d-flex > .d-flex > .ml-3,\n.clubsReportParametersModal__body .form-check > .d-flex > .d-flex > .ml-3 {\n  display: none !important;\n}\n.clubsReportParametersModal__body .sit-switch {\n  flex: 0 0 auto;\n}\n.clubsReportParametersModal__body .sit-switch__track {\n  width: 38px;\n  height: 22px;\n}\n.clubsReportParametersModal__body .sit-switch__thumb {\n  width: 18px;\n  height: 18px;\n}\n.clubsReportParametersModal__body form > .btn {\n  min-height: 40px;\n  order: 98;\n  margin-top: 16px !important;\n  margin-bottom: 16px !important;\n  padding: 0 16px;\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: 700;\n}\n.clubsReportParametersModal__body form > .btn-secondary {\n  margin-right: 8px !important;\n  margin-left: 24px !important;\n  border-color: var(--border-default, #cbd5e1);\n  background: #fff;\n  color: var(--text-body, #334155);\n}\n.clubsReportParametersModal__body form > .btn-primary {\n  order: 99;\n  margin-right: 24px !important;\n  margin-left: auto !important;\n  border-color: var(--blue-600, #227ebd);\n  background: var(--blue-600, #227ebd);\n  color: #fff;\n}\n\n.averageClubAttendanceForm {\n  display: flex !important;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  flex-direction: column;\n  flex-wrap: nowrap !important;\n  align-content: normal !important;\n  margin: 0;\n  overflow: hidden !important;\n  background: #fff;\n}\n.averageClubAttendanceForm__scroll {\n  min-height: 0;\n  flex: 1 1 auto;\n  padding: 0 8px 0 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-gutter: stable;\n}\n.averageClubAttendanceForm__customRange {\n  margin-top: 14px;\n}\n.averageClubAttendanceForm .eReportActions {\n  flex: 0 0 auto;\n  margin-top: 0;\n}\n.averageClubAttendanceForm .sit-rf__periods {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n.averageClubAttendanceForm .sit-rf__period {\n  min-height: 42px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 12px;\n}\n.averageClubAttendanceForm .sit-rf__chips {\n  gap: 7px;\n}\n.averageClubAttendanceForm .sit-rf__chip {\n  min-height: 32px;\n  padding: 5px 11px;\n  font-size: 12px;\n}\n\n@media (max-width: 560px) {\n  .clubsReportParametersModal.modal-dialog {\n    width: calc(100vw - 20px);\n    height: calc(100vh - 24px);\n  }\n  .clubsReportParametersModal__body > form > .mb-3.mt-3,\n  .clubsReportParametersModal__body .bReportFormTitle + .mb-3,\n  .clubsReportParametersModal__body .form-group,\n  .clubsReportParametersModal__body > form > .form-check,\n  .clubsReportParametersModal__body > form > .mt-3.mb-3 {\n    width: calc(100% - 28px);\n    margin-right: 14px !important;\n    margin-left: 14px !important;\n  }\n  .clubsReportParametersModal__body .clubReportDateRange .sit-cal__panes {\n    flex-direction: column;\n  }\n  .averageClubAttendanceForm__scroll {\n    padding-right: 6px;\n  }\n  .averageClubAttendanceForm .sit-rf__periods {\n    grid-template-columns: 1fr;\n  }\n}\n\n.clubsDsActiveFilters button.isClear {\n  border-color: transparent;\n  background: transparent;\n  color: var(--text-muted, #69778a);\n}\n\n@media (max-width: 760px) {\n  .clubsDsFilterAnchor {\n    position: static;\n  }\n\n  .clubsDsFilterAnchor .clubsDsFilters {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100vw;\n    max-width: none;\n    height: 100vh;\n    max-height: none;\n    border-radius: 0;\n  }\n\n  .clubsDsFilterBody {\n    grid-template-columns: 1fr;\n  }\n}\n\n.clubsDsDateRange .sit-dp__pop > div:last-child > div:last-child {\n  flex: 0 0 auto;\n  padding: 0 14px 14px !important;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n  box-shadow: 0 -8px 16px rgba(15, 23, 42, 0.08);\n}\n\n.clubsDsDateRange .sit-cal__foot {\n  position: static;\n  margin: 0;\n  padding-top: 12px;\n}\n.clubsInviteMultiWarning {\n  width: min(680px, 100%);\n  margin: 20px 0;\n  padding: 20px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 14px;\n  background: #fff;\n}\n\n.clubsInviteMultiWarning__banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px;\n  border: 1px solid #f1dfb7;\n  border-radius: 10px;\n  background: #fffaf0;\n}\n\n.clubsInviteMultiWarning__banner > span {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #eda83b;\n  color: #fff;\n  font-weight: 800;\n}\n\n.clubsInviteMultiWarning__banner strong {\n  color: var(--text-strong, #142033);\n  font-size: 14px;\n}\n\n.clubsInviteMultiWarning__banner p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #69778a);\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n\n.clubsInviteMultiWarning__clubs {\n  margin-top: 16px;\n  border-top: 1px solid var(--border-subtle, #e3e8ef);\n}\n\n.clubsInviteMultiWarning__clubs > div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 11px 2px;\n  border-bottom: 1px solid var(--border-subtle, #e3e8ef);\n}\n\n.clubsInviteMultiWarning__clubs strong {\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n}\n\n.clubsInviteMultiWarning__clubs span {\n  color: var(--text-muted, #69778a);\n  font-size: 12px;\n}\n\n.clubsInviteMultiWarning__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  margin-top: 18px;\n}\n.clubsInviteConfirmModal .modal-body {\n  padding: 20px 22px !important;\n  background: #fff;\n}\n\n.clubsInviteConfirmModal .modal-content {\n  border: 1px solid var(--border-subtle, #dbe3ec) !important;\n  border-radius: 14px !important;\n  box-shadow: 0 20px 54px rgba(15, 23, 42, 0.2) !important;\n}\n\n.clubsInviteConfirmModal .modal-header {\n  min-height: 64px;\n  align-items: center;\n  padding: 17px 22px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.clubsInviteConfirmModal .modal-title {\n  color: var(--text-strong, #142033);\n  font-size: 18px;\n  font-weight: 760;\n}\n\n.clubsInviteConfirmModal .modal-header .close {\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  border-radius: 8px;\n  color: var(--text-muted, #69778a);\n  opacity: 1;\n}\n\n.clubsInviteConfirmModal .modal-footer {\n  gap: 9px;\n  padding: 14px 22px;\n  border-top: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.clubsInviteConfirmModal .modal-footer button {\n  display: inline-flex;\n  min-height: 38px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 16px;\n  border-radius: 9px;\n  font-size: 12.5px;\n  font-weight: 750;\n}\n\n.clubsInviteConfirmModal .modal-footer button:first-child {\n  border: 1px solid var(--border-default, #cbd5e1);\n  background: #fff;\n  color: var(--text-body, #334155);\n}\n\n.clubsInviteConfirmModal .modal-footer button:last-child {\n  border: 1px solid var(--blue-600, #227ebd);\n  background: var(--blue-600, #227ebd);\n  color: #fff;\n}\n\n.clubsInviteConfirm__banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 13px;\n  border: 1px solid var(--blue-200, #cce5f5);\n  border-radius: 10px;\n  background: var(--blue-50, #eef8fd);\n}\n\n.clubsInviteConfirm__banner > span {\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  flex: 0 0 24px;\n  align-items: center;\n  justify-content: center;\n  color: var(--blue-700, #18699f);\n}\n\n.clubsInviteConfirm__banner > span svg {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.clubsInviteConfirm__banner p {\n  margin: 2px 0 0;\n  color: var(--text-body, #334155);\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n\n.clubsInviteConfirm__clubs {\n  display: grid;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.clubsInviteConfirm__club {\n  padding: 14px 16px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  background: #fff;\n}\n\n.clubsInviteConfirm__club > strong {\n  color: var(--text-strong, #142033);\n  font-size: 14px;\n  font-weight: 760;\n}\n\n.clubsInviteConfirm__club dl {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n  margin: 10px 0 0;\n}\n\n.clubsInviteConfirm__club dl > div {\n  min-width: 0;\n}\n\n.clubsInviteConfirm__club dt {\n  color: var(--text-muted, #69778a);\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.clubsInviteConfirm__club dd {\n  margin: 3px 0 0;\n  color: var(--text-strong, #142033);\n  font-size: 12.5px;\n}\n\n.clubsInviteConfirm__deadline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 14px;\n  padding-top: 13px;\n  border-top: 1px solid var(--border-subtle, #dbe3ec);\n  font-size: 12.5px;\n}\n\n.clubBookingForm .SendTimeFormEditor {\n  margin-top: 0;\n}\n\n.clubBookingForm .SendTimeFormEditor__header {\n  border-radius: 12px;\n}\n\n.clubBookingForm .SendTimeFormEditor__beforeActions {\n  padding: 14px 16px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 12px;\n  background: #fff;\n}\n\n.clubBookingForm .SendTimeFormEditor__footer {\n  align-items: center;\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid var(--border-subtle, #dbe3ec);\n}\n\n.clubsInvitationExitModal .modal-content {\n  border: 1px solid var(--border-subtle, #dbe3ec) !important;\n  border-radius: 14px !important;\n  box-shadow: 0 20px 54px rgba(15, 23, 42, 0.2) !important;\n}\n\n.clubsInvitationExitModal .modal-header {\n  min-height: 64px;\n  padding: 17px 20px !important;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec) !important;\n  background: #fff !important;\n}\n\n.clubsInvitationExitModal .modal-title {\n  color: var(--text-strong, #142033) !important;\n  font-size: 17px !important;\n  font-weight: 760 !important;\n}\n\n.clubsInvitationExitModal .modal-header button {\n  width: 34px !important;\n  height: 34px !important;\n  border: 0 !important;\n  border-radius: 8px !important;\n  background: transparent !important;\n  color: var(--text-muted, #69778a) !important;\n}\n\n.clubsInvitationExitModal .modal-body {\n  padding: 20px !important;\n  color: var(--text-body, #334155) !important;\n  font-size: 13px !important;\n  line-height: 1.5 !important;\n}\n\n.clubsInvitationExitModal__body {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.clubsInvitationExitModal__icon {\n  display: inline-flex;\n  width: 44px;\n  height: 44px;\n  flex: 0 0 44px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #fed7aa;\n  border-radius: 11px;\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.clubsInvitationExitModal__icon svg {\n  width: 22px;\n  height: 22px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.clubsInvitationExitModal__copy {\n  min-width: 0;\n  padding-top: 1px;\n}\n\n.clubsInvitationExitModal__copy strong {\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 760;\n}\n\n.clubsInvitationExitModal__copy p {\n  margin: 5px 0 0;\n  color: var(--text-muted, #69778a);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.clubsInvitationExitModal .modal-footer {\n  gap: 9px !important;\n  padding: 14px 20px !important;\n  border-top: 1px solid var(--border-subtle, #dbe3ec) !important;\n  background: #fff !important;\n}\n\n.clubsInvitationExitModal .modal-footer button {\n  min-height: 38px;\n  padding: 0 15px !important;\n  border-radius: 9px !important;\n  font-size: 12.5px;\n  font-weight: 750;\n}\n\n.clubsInvitationExitModal .modal-footer .btn-secondary {\n  border: 1px solid var(--border-default, #cbd5e1) !important;\n  background: #fff !important;\n  color: var(--text-body, #334155) !important;\n}\n\n.clubsInvitationExitModal .modal-footer .btn-primary {\n  border: 1px solid #dc2626 !important;\n  background: #dc2626 !important;\n  color: #fff !important;\n}\n\n.clubsInvitationExitModal .modal-footer .btn-primary:hover,\n.clubsInvitationExitModal .modal-footer .btn-primary:focus {\n  border-color: #b91c1c !important;\n  background: #b91c1c !important;\n  color: #fff !important;\n}\n\n.clubsDeleteModal .modal-content {\n  border: 1px solid var(--border-subtle, #dbe3ec) !important;\n  border-radius: 14px !important;\n  box-shadow: 0 20px 54px rgba(15, 23, 42, 0.2) !important;\n}\n\n.clubsDeleteModal .modal-header {\n  min-height: 64px;\n  padding: 17px 20px !important;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec) !important;\n  background: #fff !important;\n}\n\n.clubsDeleteModal .modal-title {\n  color: var(--text-strong, #142033) !important;\n  font-size: 17px !important;\n  font-weight: 760 !important;\n}\n\n.clubsDeleteModal .modal-header button {\n  width: 34px !important;\n  height: 34px !important;\n  border: 0 !important;\n  border-radius: 8px !important;\n  background: transparent !important;\n  color: var(--text-muted, #69778a) !important;\n}\n\n.clubsDeleteModal .modal-body {\n  padding: 20px !important;\n}\n\n.clubsDeleteModal__body {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.clubsDeleteModal__icon {\n  display: inline-flex;\n  width: 44px;\n  height: 44px;\n  flex: 0 0 44px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #fecdd3;\n  border-radius: 11px;\n  background: #fff1f2;\n  color: #be123c;\n}\n\n.clubsDeleteModal__icon svg {\n  width: 22px;\n  height: 22px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.clubsDeleteModal__copy {\n  min-width: 0;\n  padding-top: 1px;\n}\n\n.clubsDeleteModal__copy strong {\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 760;\n}\n\n.clubsDeleteModal__copy p {\n  margin: 5px 0 0;\n  color: var(--text-muted, #69778a);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.clubsDeleteModal .modal-footer {\n  gap: 9px !important;\n  padding: 14px 20px !important;\n  border-top: 1px solid var(--border-subtle, #dbe3ec) !important;\n  background: #fff !important;\n}\n\n.clubsDeleteModal .modal-footer button {\n  min-height: 38px;\n  padding: 0 15px !important;\n  border-radius: 9px !important;\n  font-size: 12.5px;\n  font-weight: 750;\n}\n\n.clubsDeleteModal .modal-footer .btn-secondary {\n  border: 1px solid var(--border-default, #cbd5e1) !important;\n  background: #fff !important;\n  color: var(--text-body, #334155) !important;\n}\n\n.clubsDeleteModal .modal-footer .btn-primary {\n  border: 1px solid #be123c !important;\n  background: #be123c !important;\n  color: #fff !important;\n}\n\n.clubsDeleteModal .modal-footer .btn-primary:hover {\n  border-color: #9f1239 !important;\n  background: #9f1239 !important;\n}\n\n.clubsInviteConfirm__deadline span {\n  color: var(--text-muted, #69778a);\n}\n\n.clubsInviteConfirm__error,\n.clubsInviteConfirm__warning {\n  margin-top: 10px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 12px;\n}\n\n.clubsInviteConfirm__error {\n  background: var(--red-50, #fff1f2);\n  color: var(--red-700, #b42335);\n}\n\n.clubsInviteConfirm__warning {\n  background: #fffaf0;\n  color: #8a5700;\n}\n\n/* Unified Clubs modal shell */\n.clubsModal.modal-dialog {\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.clubsModal .modal-content {\n  max-height: calc(100vh - 48px) !important;\n  border: 0 !important;\n  border-radius: 14px !important;\n  background: var(--surface-card, #fff) !important;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.24) !important;\n}\n\n.clubsModal .modal-header {\n  min-height: 62px;\n  padding: 16px 20px !important;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0) !important;\n  background: var(--surface-card, #fff) !important;\n}\n\n.clubsModal .modal-title {\n  color: var(--text-strong, #0f172a) !important;\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 18px !important;\n  font-weight: 800 !important;\n  line-height: 1.3 !important;\n}\n\n.clubsModal .modal-header .close,\n.clubsModal .modal-header > button[aria-label='Close'] {\n  display: inline-flex;\n  width: 34px !important;\n  height: 34px !important;\n  align-items: center;\n  justify-content: center;\n  margin: 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  border-radius: 8px !important;\n  background: transparent !important;\n  color: var(--text-muted, #64748b) !important;\n  line-height: 1 !important;\n  opacity: 1;\n}\n\n.clubsModal .modal-header .close:hover,\n.clubsModal .modal-header .close:focus-visible,\n.clubsModal .modal-header > button[aria-label='Close']:hover,\n.clubsModal .modal-header > button[aria-label='Close']:focus-visible {\n  background: var(--surface-sunken, #f1f5f9) !important;\n  color: var(--text-strong, #0f172a) !important;\n  outline: none;\n}\n\n.clubsModal:not(.clubsReportParametersModal):not(.clubsReportsModal) .modal-body {\n  min-height: 0;\n  padding: 18px 20px !important;\n  overflow-y: auto;\n  color: var(--text-body, #334155) !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  line-height: 1.5 !important;\n}\n\n.clubsModal .modal-footer {\n  gap: 8px !important;\n  padding: 14px 20px !important;\n  border-top: 1px solid var(--border-subtle, #e2e8f0) !important;\n  background: var(--slate-25, #fafbfc) !important;\n}\n\n.clubsModal .modal-footer .btn {\n  min-height: 38px;\n  margin: 0 !important;\n  padding: 0 14px !important;\n  border-radius: 8px !important;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 12.5px;\n  font-weight: 750;\n  box-shadow: none !important;\n}\n\n.clubsModal .modal-footer .btn-secondary {\n  border-color: var(--border-default, #cbd5e1) !important;\n  background: var(--surface-card, #fff) !important;\n  color: var(--text-body, #334155) !important;\n}\n\n.clubsModal .modal-footer .btn-secondary:hover:not(:disabled) {\n  border-color: var(--border-brand, #6fb1df) !important;\n  background: var(--blue-50, #eef6fc) !important;\n  color: var(--blue-700, #155d8c) !important;\n}\n\n.clubsModal .modal-footer .btn-primary {\n  border-color: var(--action-primary, #227ebd) !important;\n  background: var(--action-primary, #227ebd) !important;\n  color: #fff !important;\n}\n\n.clubsModal .modal-footer .btn-primary:hover:not(:disabled) {\n  border-color: var(--blue-700, #155d8c) !important;\n  background: var(--blue-700, #155d8c) !important;\n}\n\n.clubsDeleteModal .modal-footer .btn-primary,\n.clubsDeleteModal .modal-footer .btn-primary:hover:not(:disabled) {\n  border-color: #be123c !important;\n  background: #be123c !important;\n}\n\n.clubsModalBody {\n  padding-bottom: 0 !important;\n}\n\n.clubsModalContent {\n  display: grid;\n  gap: 16px;\n}\n\n.clubsModalLead {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--slate-25, #fafbfc);\n}\n\n.clubsModalLead.isWarning {\n  border-color: var(--amber-100, #ffe9c2);\n  background: var(--amber-50, #fff6e6);\n}\n\n.clubsModalLead.isDanger {\n  border-color: #fecdd3;\n  background: #fff1f2;\n}\n\n.clubsModalLead.isInfo {\n  border-color: #bfdbfe;\n  background: var(--blue-50, #eef6fc);\n}\n\n.clubsModalLead.isSuccess {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n}\n\n.clubsModalLeadIcon {\n  display: inline-flex;\n  width: 36px;\n  height: 36px;\n  flex: 0 0 36px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n}\n\n.clubsModalLead.isWarning .clubsModalLeadIcon {\n  background: var(--amber-100, #ffe9c2);\n  color: var(--amber-700, #a85c07);\n}\n\n.clubsModalLead.isDanger .clubsModalLeadIcon {\n  background: #ffe4e6;\n  color: #be123c;\n}\n\n.clubsModalLead.isInfo .clubsModalLeadIcon {\n  background: #dbeafe;\n  color: var(--blue-700, #155d8c);\n}\n\n.clubsModalLead.isSuccess .clubsModalLeadIcon {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.clubsModalLeadIcon svg {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.clubsModalLead > div {\n  min-width: 0;\n}\n\n.clubsModalLead strong {\n  display: block;\n  margin-bottom: 3px;\n  color: var(--text-strong, #0f172a);\n  font-size: 13.5px;\n  font-weight: 750;\n}\n\n.clubsModalLead p {\n  margin: 0;\n  color: var(--text-body, #334155);\n}\n\n.clubsArchiveList {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n}\n\n.clubsArchiveList > div {\n  display: flex;\n  min-height: 48px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 9px 12px;\n}\n\n.clubsArchiveList > div + div {\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.clubsArchiveList strong {\n  overflow: hidden;\n  color: var(--text-strong, #0f172a);\n  font-size: 12.5px;\n  font-weight: 750;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.clubsArchiveList span {\n  display: inline-flex;\n  min-height: 24px;\n  flex: 0 0 auto;\n  align-items: center;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 10.5px;\n  font-weight: 800;\n}\n\n.clubsArchiveList span.isWarning {\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n}\n\n.clubsModalActions {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  margin: 0 -20px;\n  padding: 14px 20px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-25, #fafbfc);\n}\n\n.clubsModalActions.isEnd {\n  justify-content: flex-end;\n}\n\n.clubsDsFilterAnchor .clubsDsFilterActions > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.clubsModalButton {\n  display: inline-flex;\n  min-height: 38px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 14px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 12.5px;\n  font-weight: 750;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.clubsModalButton.isSecondary {\n  border-color: var(--border-default, #cbd5e1);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n}\n\n.clubsModalButton.isSecondary:hover,\n.clubsModalButton.isSecondary:focus-visible {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  outline: none;\n}\n\n.clubsModalButton.isPrimary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.clubsModalButton.isPrimary:hover,\n.clubsModalButton.isPrimary:focus-visible {\n  border-color: var(--blue-700, #155d8c);\n  background: var(--blue-700, #155d8c);\n  outline: none;\n}\n\n@media (max-width: 600px) {\n  .clubsModal .modal-content {\n    max-height: calc(100vh - 24px) !important;\n  }\n\n  .clubsModal .modal-header {\n    min-height: 58px;\n    padding: 13px 16px !important;\n  }\n\n  .clubsModal:not(.clubsReportParametersModal):not(.clubsReportsModal) .modal-body {\n    padding: 14px 16px !important;\n  }\n\n  .clubsModalBody {\n    padding-bottom: 0 !important;\n  }\n\n  .clubsModalActions {\n    margin-right: -16px;\n    margin-left: -16px;\n    padding: 12px 16px;\n  }\n\n  .clubsModalActions .clubsModalButton {\n    flex: 1 1 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
